var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacturacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 237.2 264.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .7;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: .45px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #808184;\n      }\n\n      .cls-4, .cls-5, .cls-3, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-width: 0px;\n      }\n\n      .cls-4, .cls-6 {\n        fill: #d0d2d3;\n      }\n\n      .cls-10 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-5, .cls-6, .cls-9 {\n        fill-rule: evenodd;\n      }\n\n      .cls-11 {\n        isolation: isolate;\n      }\n\n      .cls-12 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-13 {\n        letter-spacing: .02em;\n      }\n\n      .cls-3 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-14 {\n        letter-spacing: 0em;\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        fill: #333343;\n      }\n\n      .cls-15 {\n        letter-spacing: .02em;\n      }\n\n      .cls-16 {\n        font-family: Gibson-SemiBold, Gibson;\n        font-size: 8.88px;\n        font-weight: 600;\n      }\n\n      .cls-16, .cls-17 {\n        fill: #231f20;\n      }\n\n      .cls-18 {\n        letter-spacing: 0em;\n      }\n\n      .cls-17 {\n        font-family: Gibson-Regular, Gibson;\n        font-size: 3.24px;\n      }\n\n      .cls-9 {\n        fill: #230000;\n      }\n\n      .cls-19 {\n        letter-spacing: -.07em;\n      }\n\n      .cls-20 {\n        fill: none;\n        stroke: #231f20;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: .78px;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.05,
    dy: 6.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 4.32
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 35.18,
    y: 23.66,
    width: 166.84,
    height: 217.08,
    transform: "translate(-41.56 55.44) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 37.71,
    y: 25.79,
    width: 161.78,
    height: 212.81,
    rx: 16.6,
    ry: 16.6,
    transform: "translate(-41.56 55.44) rotate(-22.5)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 41.14,
    y: 23.03,
    width: 166.84,
    height: 217.08,
    transform: "translate(-28.98 35.38) rotate(-14.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 43.67,
    y: 25.16,
    width: 161.78,
    height: 212.81,
    rx: 16.6,
    ry: 16.6,
    transform: "translate(-28.98 35.38) rotate(-14.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.08,
    y1: 156.88,
    x2: 107.06,
    y2: 187.71
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 49.65,
    y: 20.79,
    width: 166.84,
    height: 217.08,
    transform: "translate(-11.42 12.9) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m60.26,39.98c0-.11-.03-.21-.14-.18-.29.12-.7.61-.67.88.06.64.39,1.44.75,1.59.15.05.63-.06.8-.18.02-.04-.06-.17-.07-.23-.12.01-.4.17-.54.11-.39-.07-.46-.81-.45-1.2l.31-.7c-.13.16-.36.31-.44.28-.04-.15.33-.5.46-.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m61.11,41.26c.04.27-.75.44-.84.05.27.11.63.1.84-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.41,41.4c.61-.29,1.28.93.78,1.54.14-.53-.12-1.44-.78-1.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.03,41.63s.02-.09.03-.07c.03.05.11.04.14.04.34,0,.74.47.87,1.08.09.53-1.15,1.84-1.52,2.46-.15.49.3,1.03.19.98-.98-.46-.37-1.42-.3-1.51.91-1.27,1.83-1.9.94-2.66,0,0-.25-.06-.31-.1-.05-.04-.06-.15-.03-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.36,47.35s.21-.3.23-.33c0-.01,0-.05.07-.15.17-.35,0-.93-.46-1.15-.51-.27-1.26.17-1.97.04-.36-.15-.44-.72-.46-.63-.17.83.66.85.74.84,1.15.04,1.86-.45,1.93.65,0,0-.01.11-.04.17-.12.17-.28.42-.28.42-.07.02.2.1.23.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.1,39.55c-.25-.19-.66-.26-.95-.3-.01,0-.04.05-.06.1.18,0,.75.15.99.28.04.02.03-.07.03-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.38,41.04c-.02-.32-.06-.51-.04-.72,0,0-.08.08-.12.08.05.1.07.49.04.65,0,.02.13-.01.13-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.28,44.59c-.2-1.03-.17-1.07-.19-1.5,0,0,.1,0,.23-.02-.16.2.12,1.39.3,1.64,0,.01-.17,0-.34-.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.51,44.29c-.25-.97-.2-.97-.2-1.38,0,0,.08,0,.21-.03-.16.18,0,.97.16,1.22,0,0,0,.3-.17.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.42,43.51c-.18-.68-.18-.64-.21-.93,0,0,.05-.03.13-.05-.11.13.12.48.23.93.05.13.02.17-.15.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.01,42.35c-.16-.27-.15-.27-.24-.36,0,0-.02.01-.07.05.09-.02.11.18.21.36.04.06.05.06.09-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.92,42.57c.07-.32.13-.58.18-.77,0,0-.08,0-.13,0,.01.12-.15.59-.17.77h.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.32,42.61c.09-.31.19-.57.27-.76,0,0-.1,0-.15-.01.01.12-.2.56-.24.74,0,.01.12.02.12.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.91,42.43c0-.46,0-.74-.01-1.03,0,0-.07.12-.13.12.01.15-.04.74-.02.97,0,.01.15-.06.16-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.29,40.45c-.18-.4-.31-.63-.41-.89,0,0-.02.13-.07.15.1.12.29.59.35.81.01.02.11-.07.13-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.97,42.02c-.06-.53-.13-.87-.15-1.21,0,0-.06.14-.11.14.07.19.12.83.12,1.12,0,.02.13-.05.14-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.24,39c.52.19.84.28,1.16.42,0,0-.09-.11-.08-.16-.19-.03-.79-.25-1.05-.4-.02,0-.02.13-.04.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m71.21,37.95c.41-.16,3.21,2.37,3.7,3.06,0,0,.17-.06.19-.1-.2-.45-3.16-3.2-3.75-3.12,0,0-.14.16-.14.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.74,40.39c.2-.08,1.36.75,1.59,1.08,0,0,.21.02.13-.06-.1-.22-1.36-1.22-1.64-1.18l-.08.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.42,41.46c.15.02.67.39.96.58,0,0,.21.02.11-.07-.13-.14-.81-.74-1.03-.76,0,0-.03.24-.04.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.9,42.39c.13.02.2.13.49.32,0,0,.21.02.13-.07-.15-.14-.35-.42-.56-.45l-.05.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.2,43.23c.13.02.17.14.37.33,0,0,.04-.08.08-.16-.15-.14-.19-.2-.34-.32l-.11.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.17,43.88c.13.02.58.68.79.88,0,0,.03-.07.06-.16-.13-.14-.69-.87-.85-.98v.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.42,44.65c.13.02.66.78.87.98,0,0,.03-.07.07-.16-.15-.14-.66-.85-.8-.95l-.14.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.19,45.73c.13.02.58.71.68,1.03,0,0,.04-.04.08-.13-.08-.19-.5-1.01-.65-1.08-.14-.07-.2.13-.12.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.22,46.47c.11,0,.69.58.84.88,0,0,.06,0,.09-.08-.05-.19-.63-.85-.77-.93-.15-.08-.29,0-.16.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.64,48.19c.07,0,.37.36.46.55,0,0,.07,0,.1-.06-.03-.12-.29-.49-.37-.53-.09-.05-.27-.02-.19.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69,48.38s.3.26.39.44c0,0,.08,0,.11-.06-.04-.13-.36-.47-.43-.51-.09-.04-.07.05-.07.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.4,46.96c.14.11.71.53,1.07.91,0,0,0,.05.02-.04-.26-.37-.84-.85-.95-.93-.38-.29-.31-.26-.14.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.74,44.48c.13.02.56.75.76,1.29,0,0,.02-.06.05-.15-.07-.27-.62-1.24-.76-1.33,0,0-.04.18-.04.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.44,45.2c.13.02.71.76.91.95,0,0,.07-.03.11-.12-.15-.14-.76-.81-.9-.89l-.11.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.66,40.2c.32.16.53.29.53.3-.02.03.04-.11.04-.17-.1-.01-.43-.14-.59-.26-.02,0,.01.13.01.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.37,41.34c.31.15.32.16.32.16-.02.03.06-.09.07-.15-.1-.02-.15-.08-.32-.16,0,0-.07.14-.07.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.84,42.24c.31.15.27.18.27.18,0,.02.08-.09.08-.15-.09-.06-.12-.09-.28-.17,0,0-.07.13-.07.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.79,39.97c-.3-.36-.58-.63-.75-.87,0,0,0,.08-.04.11.14.1.57.66.69.86.01.02.1-.11.1-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m60.73,39.86s.06-.15.08-.13c.14.19.18.43.04.69,0-.23-.02-.37-.12-.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m61.21,40.37c.2.21-.93,1.06-1.08.79-.06-.13.09-.79.22-1.1.09-.21,0-.35-.06-.36-.12-.01.16-.27.17-.27.26-.19.35.12.27.21-.28.35-.15.45-.12.43.08-.06.02.35-.21.56-.05.03-.08.2-.01.27.27-.07.7-.31.82-.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.12,40.88c-.14.05-.24-.03-.28-.01.02.19-.08.22-.39.2-.11.06-.23.23-.27.31-.24.55.24,1.17,1.13.92-.8-.49-.43-1.09.43-1.07,0-.04.34-.22.33-.3-.05,0-.42-.03-.58-.02-.07,0,.12.16.05.16-.51.06-1.25.47-.75,1.02.01.02-.59.03-.45-.59.03-.11.1-.26.18-.27.13-.01.34-.04.38-.08l.21-.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m61.7,40.69c1.49.05,1.36-.07,1.56-.1.14-.01.45-.03.68.26.11.13-.53.59-.91.67.31-.32.65-.53.53-.63-.12-.04-.35-.06-.49.03-.11.09-.37,0-.59,0-.11-.01-.23-.03-.37-.01-.11,0-.28-.02-.43-.02-.08,0,0,0,.02-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.31,38.92c.01.14,0,.7-.14.82-.13.24-.48.21-.44.74.23.13.41.07.6,0l-.02-.13c-.38.05-.48.04-.34-.16-.02-.07.25-.17.4-.52,0,.17-.17.66-.18.69q.1,0,.12,0s.08-.38.14-.57c0-.05.08-.09.07-.1.06-.17,0-.48-.22-.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.52,39.95s0-.23.08-.18c.24.21.33.55-.19.79.25-.29.29-.51.11-.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.99,39.08s.1-.09.09-.15c-.05-.27-.47-.51-.45-.44.06.27.1.57.05.93-.02-.05.11-.07.14-.15.07-.19.02-.28,0-.45,0-.04.13.06.16.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.93,38.89s.09.21.13.16c.44-.67.04-1.04-.23-1.04-.23,0,0,.37-.26.67,0-.05.04.16.11.11.16-.13.16-.24.23-.41.02-.03.16.18.02.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.6,39.67s.12.16.18.12c.62-.47.93-.95.38-1.65.14.7.14,1.02-.55,1.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.92,40.14s-.09.18.04.15c.38-.06,1.19-.99.9-1.15-.04-.02-.06-.09-.07-.09-.25.02-.62.59-.93.83.03-.04,0,.13.07.1.28-.11.68-.71.79-.66.11.04-.5.67-.8.82h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.44,38.68s-.15-.14-.04-.16c.26-.02.9.26,1.21.18.08-.02.27.04.28.13.01.02-.13.41-.17.41-.27.05-.96-.22-1.35-.29.05.02-.08-.11.01-.12.29,0,1.08.3,1.19.23.01,0,.08-.02.04-.04-.18-.13-.91-.34-1.17-.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.71,38.37s-.11-.06-.11-.11c0-.13.43-.05.47-.08.02-.01.05,0,.1.04,0,.01.32.42.29.49-.06.14-.29.08-.43.12.04,0-.14-.13-.11-.13.18-.03.36,0,.35-.08,0-.02-.13-.28-.18-.3-.17-.03-.26.02-.38.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.39,37.04c.05.03-.11-.07-.16-.06-.13.05.12.41.11.46,0,.02.07.05.12.09,0,0,.43.15.5.1.11-.09.02-.3.02-.45.01.02-.24-.07-.22-.05.04.18.09.3.02.32-.04,0-.22,0-.24-.04-.08-.14-.13-.24-.14-.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.2,36.92s-.23-.05-.28-.02c-.1.07.51.41.5.46,0,.01.04.04.1.05,0,0,.52.07.57,0,.08-.13-.11-.3-.15-.44.01.01-.23-.05-.22-.02.09.15.13.24.06.27-.02.01-.21.04-.24.02-.12-.11-.3-.21-.34-.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.17,39.13c.03.06-.04-.14-.01-.14.18,0,.33-.03.38-.06.02-.01.07.03.1.09.03.1.3.6.2.73-.12.16-.39.06-.52.1.04,0-.11-.12,0-.17.15-.05.35-.03.36-.08.03-.09-.11-.4-.17-.42-.14-.05-.22-.05-.34-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.4,40.16c.04.06,0-.16.03-.16.15-.05.34-.04.41-.04.13.02.19.14.21.21.05.24.04.22-.03.37-.08.18-.17.39-.29.45.03,0-.08-.21-.02-.31.09-.15.15-.24.14-.29.04-.18-.08-.24-.14-.25-.15-.01-.2,0-.31.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.64,38.02c.07.03-.27-.08-.28-.12,0-.08.63,0,.54-.13-.03-.03.1-.03.27.04.04,0,.44.16.44.24,0,.1-.12.13-.32.16.05,0-.18,0-.21-.05-.03-.11.4-.01.33-.08,0,0-.22-.15-.35-.12-.11.01-.4,0-.43.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.23,39.18s-.02-.11.06-.13c.13-.05,1.35.33,1.28.54,0,0-.09.21-.2.38-.2.26-.91-.32-1.25-.4.05.03-.06-.11.01-.11.3,0,1,.3,1.11.34.1.01.15-.19.11-.23-.2-.17-.8-.43-1.12-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.2,39.81s-.04-.07.03-.1c.12-.04.96.28.88.5,0,0-.11.29-.26.39-.11.07-.33-.32-.52-.43.05.02-.05-.28.03-.16.11.17.3.3.4.32.07.03.16-.13.13-.14-.19-.14-.41-.27-.68-.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.2,40.37s0-.08.06-.08c.1.01.43.38.31.5,0,0-.15.19-.29.22-.09.02-.17-.3-.28-.43.03.03.1-.24.12-.13.05.15.08.12.18.3.03.05.05-.02.04-.08,0-.19.01-.15-.15-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.01,37.59s-.05-.04-.02-.08c.04-.06.47-.16.5-.02,0,0,.08.2.03.31-.03.07-.29.01-.43.03.04,0-.14-.18-.05-.15.14.04.13,0,.29,0,.06,0,.02-.04-.03-.07-.14-.07-.09-.06-.29,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.65,40.94s.08-.2.13-.16c.08.09.17.54-.19.91-.05.07-.37.13-.44-.03-.05-.12.02-.33.23-.6,0,.05.18-.21.14-.1-.08.16-.12.31-.16.52,0,.05.07.13.17-.06.11-.21.1-.18.11-.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.43,40.18s.11-.25.14-.18c.08.23.27,1,.06,1.38-.07.11-.52.25-.66.05-.08-.11,0-.48.02-.82,0,.06.19-.15.15-.04-.05.2-.08.46.01.66.01.02.25.09.31-.1.09-.22.03-.62-.04-.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.9,43.2c.04.06-.15-.07-.17.06-.11.59.08,1.34.46,1.83.12.15.65.29.84,0,.14-.2-.08-.74-.25-1.26,0,.01,0-.47-.05-.58-.06-.13-.2.03-.21.04-.03.04,0,.48,0,.53,0,.46.35.56.27,1.13,0,0-.41.04-.54-.13-.33-.4-.34-1.11-.34-1.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.06,43.11c.07-.05,0-.36-.2.09-.3.69.39,1.18.48,1.82.03.18.35.44.51.11.14-.3-.23-.7-.37-1.26,0,.02.07-.57.02-.69-.04-.12-.17-.06-.18-.04-.02.03-.05.59-.06.63.02.45.38.64.35,1.2,0,0-.14.1-.16-.12-.02-.39-.83-.84-.4-1.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.14,42.95c.04.06-.15-.07-.17.06-.12.56.07,1.28.46,1.75.11.15.61.05.64-.19.08-.33-.01-.5-.18-1.02,0,.02,0-.6-.06-.69-.06-.1-.17-.02-.18,0-.02.03.04.42.03.57-.02.37.17.75.21,1.04,0,0-.27.19-.41.03-.31-.38-.34-1.06-.34-1.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.15,42.65s-.15-.06-.19.05c-.12.48.05,1.1.44,1.5.11.11.47-.13.52-.31.1-.26.1-.35-.06-.74,0,.01-.3-.68-.36-.76-.05-.07-.12.05-.13.06-.02.03.19.46.22.57.1.3.18.42.15.68-.02.05-.21.28-.29.15-.2-.38-.34-.79-.32-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.21,43.47c.03.06-.03-.27.03-.22.44.44.97.96,1.2,1.49.06.13.02.61-.22.65-.33.03-1.06-.85-1.23-1.18-.04-.07.1-.18.13-.19.02-.01.85,1.09,1.03,1.11.01,0,.18-.25.08-.44-.18-.37-.7-.93-1.01-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.7,44.38s.12-.22.15-.17c.41.57.86.98,1.02,1.52.07.2-.09.43-.29.47-.34.07-1.26-1-1.48-1.3-.04-.04-.02-.03.17-.15.01-.01.95,1.15,1.11,1.16,0,0,.37-.01.26-.31-.14-.38-.63-.94-.93-1.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.75,45.07s.03-.19.1-.12c.49.45.91.77,1.08,1.29.05.19,0,.35-.18.4-.34.07-1.41-.93-1.62-1.23-.01-.03-.02-.05.18-.15,0,0,1.08,1.15,1.24,1.15,0,0,.3,0,.14-.3-.2-.34-.62-.77-.94-1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.41,46.1s.08.08.14.13c.01.02.07-.05-.04.14-.03.04-.07.05-.14.06-.15.01-.37-.48-.36-.76,0,0,.13.14.17.19.01.01.03.29.14.36,0,0,.01.01.04-.05.05-.12-.02-.05.03-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.7,45.55c.03.06.12-.13.17-.06.46.45.65.67.98.97.35.32.18.38,0,.34-.77-.14-1.69-1.27-2.03-1.49,0,0,.12,0,.29,0,0,0,1.37,1.21,1.53,1.22,0,0,.23.18.02-.05-.28-.27-.64-.64-.96-.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.67,44.76s-.11.11-.03.22c.31.39.74,1.25.84,1.66.11.45.26.34.3.16.26-.93-.41-2.47-.76-2.76,0,0-.03.03-.12.12,0,0,.88,1.05.8,2.24,0,0-.02.16-.12-.03-.22-.47-.65-1.3-.91-1.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.12,45.92s-.16.09-.09.18c.31.46.54.95.9,1.26.33.31.41.05.42-.11.07-.94-.44-1.62-.75-2.02,0,0-.05.08-.12.17,0,0,.73.74.69,1.69,0,0-.07.16-.19.05-.41-.36-.58-.67-.86-1.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.15,46.57s-.2.07-.12.14c.38.37.85.95,1.25,1.19.37.23.44-.06.39-.19-.36-.99-.47-1.01-.85-1.5,0,0-.1.03-.15.15,0,0,.52.29.79,1.24,0,0-.03.16-.17.08-.46-.27-.76-.63-1.14-1.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.46,48.23c.05.03-.4-.18-.27-.05.38.36.61.74.99.99.42.27.44-.04.41-.19-.07-.41-.27-.72-.64-1.18,0,0-.04.11-.09.22,0,0,.23.39.51.84.02.03-.05.14-.15.09-.36-.16-.42-.3-.78-.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.24,47.68s-.16-.03-.12.02c.13.23.47.71.73.95.24.23.23.05.2-.09-.17-.62-.29-.72-.51-1.11,0,0-.06.03-.11.11,0,0,.17.13.45.79,0,0,.01.15-.06.08-.29-.29-.31-.38-.56-.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.27,46.98c.05.03-.3,0-.22.04.47.32,1.1,1.01,1.55,1.26.29.16.33-.1.28-.22-.1-.29-.34-.59-.94-1.22,0,0-.14-.04-.17.08,0,0,.36.1.89,1,0,0-.02.18-.1.13-.36-.28-.82-.64-1.28-1.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.71,42.16s-.06-.02-.06.03c.02.21.11.57.36.75.06.04.19-.03.23-.11.07-.11.15-.24.05-.41.05-.03-.27-.67-.35-.66-.05,0-.07.05,0,.19,0,.01.17.37.18.42.06.14.05.18.01.29,0,.02-.05.09-.1.05-.17-.13-.33-.34-.31-.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.41,42.81s-.06.22-.04.24c.38.43,1.11,1.37,1.16,1.25.06-.11.05-.37-.07-.53.03-.03-.88-1.31-.95-1.29-.04,0-.07.13.01.24.13.19.83.87.77,1.07,0,0-.07.07-.09.03-.15-.19-.77-.82-.79-1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.16,41.78s.11-.06.13,0c.06.22.06.79-.18,1.13-.07.1-.44.19-.6-.02-.12-.14.14-.97.33-1.33,0,.06.13.08.04.25-.08.15-.28.74-.2.93,0,.01.25.11.33-.05.1-.2.19-.58.16-.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.04,41.3s.2-.09.2,0c.01.29.2,1.03-.06,1.47-.07.14-.67.38-.84.14-.1-.12.07-.8.1-1.21.02.07.14-.17.13-.04-.03.32-.12.83-.02,1.06,0,.02.39.04.48-.16.1-.25.09-.85,0-1.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.91,39.48s-.04-.3.06-.17c.34.44.76,1.06.66,1.42-.04.14-.45.56-.65.34-.1-.12-.21-.71-.28-1.18.03.08.02-.21.07-.07.1.27.21.71.34.94.01.01.28-.07.32-.29.02-.28-.28-.69-.51-.99h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.89,37.81s-.33-.19-.2-.16c.55.06,1.86.34,2.03.59.06.09.17.65-.12.62-.16,0-1.24-.4-1.6-.63.07.03-.13-.22-.02-.17.24.09,1.25.51,1.48.55,0,0,.02-.25-.1-.39-.14-.18-1.12-.36-1.48-.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m71.06,38.93s-.23-.33.01-.28c.59.1,2.93,2.13,3.01,2.42.13.36-.24.68-.56.39-.79-.71-1.98-1.74-2.5-1.94.06.05-.06-.22.02-.35.08-.15,2.39,1.93,2.56,2.04,0,0,.24.05.18-.12-.07-.21-2.37-2-2.71-2.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.94,39.95s-.13-.22.07-.19c.46.08,2.05,1.55,2.07,1.73.03.35-.44.55-.63.42-.65-.43-1.26-.98-1.66-1.13,0-.17-.02.22,0-.3,0-.13,1.55,1.13,1.65,1.2,0,0,.46.05.42-.23-.01-.13-1.64-1.37-1.92-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.61,41.07s.02-.21.05-.2c.46.07,1.38,1.01,1.4,1.19.04.34-.44.55-.63.42-.64-.42-.74-.48-1.15-.63.06-.13.07-.1.1-.26,0-.11.94.58,1.06.66,0,0,.4.01.36-.26-.02-.13-.93-.83-1.18-.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.1,42.08s.03-.18.1-.17c.46.14.82.66.85.82.04.34-.52.49-.7.39-.63-.41-.26-.23-.67-.37.05-.12.08-.07.1-.19.03-.11.55.27.66.35,0,0,.32.03.34-.22.01-.12-.43-.5-.68-.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m71.69,37.7c.02.06.19-.28.24-.26,2.75,1.35,3.4,3.62,4.33,4.07.4.18-1.04.13-1.42-.1-.97-.61-2.44-2.55-3.8-3.05.08.08-.15-.29-.12-.29,1.95.5,3.49,2.91,4.03,3.16,0,0,.63.21.52-.01-.52-.98-2.78-3.37-3.78-3.52h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.24,38.71s-.15-.17-.06-.16c.64.07,1.41.47,1.59.65.07.08.16.65-.12.64-.12,0-.76-.07-1.12-.32.07.03-.03-.05-.06-.25-.02-.07.85.38,1.05.3,0,0,.13-.24.03-.36-.15-.15-.94-.42-1.3-.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.6,39.88s-.04-.18,0-.17c.43.08.8.35.91.53.04.07.04.69-.13.61-.38-.17-.45-.03-.77-.28-.02-.11,0-.08-.01-.25,0-.06.58.38.7.31,0,0,.09-.22,0-.35-.09-.15-.47-.32-.71-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.23,41.49s-.08.13-.06.16c.31.27.52.34.72.29.06,0,.39-.58.28-.69-.04-.06-.22-.29-.66-.35.02.03-.06.28-.03.19,0-.02.39.04.46.26,0,0-.05.32-.17.34-.15.04-.33-.09-.55-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.73,42.33s-.05.1-.04.12c.29.26.38.43.56.38.03-.02.46-.51.37-.64-.02-.03-.12-.22-.53-.41.02.03-.09.27-.08.19,0-.01.36.05.44.26,0,0-.16.33-.27.36-.14.04-.25-.14-.47-.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.96,40.69s.08-.15.14-.03c.26.48.23,1.16.11,1.54-.06.16-.43.62-.64.24-.07-.13-.15-.85-.13-1.31.02.07.13-.17.14-.04.05.26.1,1.25.21,1.21.07-.03.24-.1.3-.36.06-.27-.03-.85-.13-1.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m71.02,46.13c.08,0,0,.2.07.25.64.37,3,1.81,3.53,1.88.22.03,1.26-.41.83-.65-.14-.09-3.91-1.95-4.5-2.16.1.06,0,.16.1.21.25.14,4.29,2.05,4.2,2.11-.07.04-.37.32-.69.24-.36-.09-3.1-1.57-3.54-1.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.96,46.8c.07,0-.11.12-.03.17.5.35,2.25,1.6,2.68,1.68.15.02.98-.03.69-.28-.1-.09-.41-.09-.16-.07.06,0-.37.19-.61.11-.3-.08-2.21-1.33-2.57-1.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.73,47.25s-.24.03-.06.16c.38.25,1.83,1.43,2.13,1.48.1.01.75-.03.65-.11-.07-.05-.2-.08-.23-.1,0,0-.23.07-.41.03-.2-.07-1.83-1.25-2.1-1.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m71.06,46.54s-.14.08.03.19c.36.24,2.57,1.5,2.55,1.48-.03-.06.27-.03.21-.04-.17-.06-2.53-1.4-2.79-1.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.85,47.04s-.12.03-.02.13c.24.27,1.96,1.43,2.01,1.37.03-.03.23,0,.18-.03-.14-.05-1.97-1.27-2.17-1.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.91,47.77s.03.18.08.23c.55.61,1.18.94,1.24.95.31.06.28-.06.26-.08-.43-.2-.23,0-1.58-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.98,45.77s-.14.07.12.27c.3.24,3.44,1.81,3.44,1.79-.02-.06.27-.1.22-.12-.15-.03-3.51-1.72-3.77-1.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.08,39.04s-.19-.28,0-.16c.45.27,1.16.82,1.18,1.21,0,.18-.45.61-.49.45-.05-.18-.04-.13-.03-.2,0,0,.26-.13.24-.35-.04-.25-.6-.75-.91-.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.36,41.91s-.01-.14-.11-.03c-.24.29-.46.69-.35.92.1.19.54.23.51.11-.02-.11-.02-.08-.05-.12,0,0-.25-.01-.3-.13-.07-.15.14-.55.29-.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.91,48.46s-.16.09-.05.19c.18.17.42.43.6.56.1.06.28-.12.26-.17-.02-.08-.05-.1-.09-.11,0,0-.16.1-.22.04-.07-.09-.34-.32-.49-.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.24,40.48c-.03.05,0-.34.1-.13.19.49.53,1.38.22,1.69-.11.11-.2.17-.17.08.05-.14.02-.22.03-.23,0,0-.04.04.04-.1.13-.2-.1-.94-.21-1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.21,39.49s.02.12,0,.16c-.03.04-.13,0-.19-.14-.58-1.64-2.27-1.01-2.31-1.41s-.08-.62.02-.87c.03-.1.33-.15.57-.2.31-.05.03.24-.02.22-.09-.04-.34,0-.36.12-.03.21-.09.43.02.59.12.16,1.66-.25,2.28,1.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.21,38.88c.14-.04.41,1.01.43,1.37,0,.11-.46,1.1-.76,1.28-.01,0-.06-.38-.04-.39.26-.14.5-.72.48-.9-.08-.74-.19-.82-.42-1.28-.73-1.48-2.09-1.17-2.25-1.45-.22-.39-.07-.62.02-.87.04-.09,2.77-.82,5.39.37.14.06.53.15.86.1.08,0-.46.53-.82.66-.12.03-.51.24-.86.03,0,0-.12-.27-.12-.34.02-.09.36,0,.27-.03-.05,0,0,.2.07.2.2,0,.68-.18.68-.18-1.93-1.21-5.23-.77-5.24-.68-.06.25-.13.43.03.55.14.12,1.65-.08,2.27,1.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.55,40.38s.04.13.14.09c.32-.15.71-.4.41-.64-.02,0-.33-.02-.37.03-.13.17-.6.4-.94.65.03-.03-.24.15.02.11.35-.07,1.15-.84,1.16-.6,0,.12-.13.13-.42.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.81,38.46l.2-.02.08.14c-.07,0-.13.02-.21.02l-.07-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67,37.3l.33-.04.21.11c-.12.01-.19.03-.33.03l-.21-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.24,39.25h.2s.08.24.08.24c-.06.02-.14.03-.22,0l-.07-.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.5,40.33l.18-.05.05.14c-.06,0-.03.11-.11.09l-.11-.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.21,41.47c.24.09.42.23.59.38,0,.12-.11.29-.24.42-.05-.07-.1-.17-.15-.24.03-.06.09-.07.13-.11-.1-.15-.25-.23-.43-.32.03-.04.07-.08.1-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.56,42.86c.26.06.5.3.64.47.01.12-.11.23-.24.36-.3.61-.22.14-.23-.01.03-.07.14-.31.18-.35-.1-.14-.29-.23-.45-.32.03-.05.06-.1.1-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.64,40.79c.19.09.38.17.57.22.04,0,.07,0,.09-.02-.11.29-.25.49-.44.71-.19-.11-.36-.21-.54-.35.03-.05.04-.1.08-.15.1.12.27.2.41.26.05-.09.09-.19.14-.28-.17-.07-.28-.19-.4-.28.04-.05.03-.07.07-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.71,39.78c.22,0,.37.15.57.09.02-.03.04-.06.05-.1.07.38.12.85.03.96-.22.04-.4.01-.62-.07,0-.08.04-.21.05-.28.15.07.24.1.39.08,0-.12-.02-.26-.01-.38-.19.02-.28-.07-.43-.09.02-.09-.04-.12-.03-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.37,38.67c.2,0,.36.09.54,0,.02-.03.02-.05.04-.09.14.36.33.81.35,1.06-.22.09-.46-.02-.71-.05,0-.08.02-.21,0-.28.16.03.26.05.41,0-.03-.12-.08-.33-.1-.45-.17.06-.29,0-.43,0,0-.08-.08-.1-.09-.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.17,37.03c.17-.12.85-.12,1.06-.15,0-.05.13,0,.17-.09.34.18.76.59.95.76-.1.24-.4.07-.65.14-.11-.12-.11-.1-.16-.15.15-.07.29,0,.41-.06-.13-.06-.42-.29-.47-.4-.13-.01-.97.03-1.11.08-.07-.07-.14-.07-.21-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.87,37.84c.2-.05.3-.02.52-.07,0-.02.03-.07.04-.1.25.24.39.56.41.76-.2.09-.32.04-.56.04-.03-.06-.06-.14-.09-.2.17,0,.26,0,.39-.06-.04-.08-.1-.18-.14-.26-.15.03-.25.04-.39.06-.03-.06-.15-.11-.17-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.52,42.48s.05-.09-.03-.24c-.01-.01-.06.17-.13.24-.39.6-1.23.86-1.53,1.78-.21.67-.16,1.38.21,2.01.43.74,1.92.28,2.7.21.23,0,.12.37.13.5.07-.04.17-.28.18-.29.12-.41-.16-.5-.25-.48-1.32.29-2.1.3-2.47-.19-.54-.73-.43-1.26-.19-1.68.57-.98.78-.78,1.39-1.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m76.01,41.85c.06.26.26.64.41.96.07.14.17.37.16.47-.05,1.6.39,4.28.05,4.54,0-.08-.05-.18-.06-.26-.07-1.29-.72-2.46-.94-3.69-.02-.09-.06-.26-.11-.33-.28-.41-.78-.34-1.26-1.89.06,0,.13-.19.15-.16.11.12.14-.01.17.14.21,1.17.8,1.22,1.14,1.68.04.06.16.21.17.4,0,.43.48,1.9.53,2.2.03.14.14.23.13.07-.14-.96-.17-1.69-.27-2.46,0-.05,0-.2-.01-.28-.03-.29-.23-.54-.58-1.44l.32.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m75.38,43.74c.39,1.59.59,1.93.57,3.55-.03-.06-.1-.12-.11-.23-.13-1.13-.88-1.95-1.19-3.12-.02-.05,0-.29-.19-.49-.31-.34-.59-.37-1.37-1.46.08-.07.25-.46.31-.13.21.85.95,1.01,1.31,1.42.04.03.09.34.12.51.09.41.53,1.36.6,1.64.02.12.16.17.12.01-.07-.98-.28-1.2-.53-1.92-.05-.18.33.1.36.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m74.28,43.59c.41,1.16.79,1.73.84,3.35-.03-.06-.08.06-.13-.22-.15-.94-.88-1.42-1.26-2.83-.05-.16-.14-.08-.26-.2-.48-.53-.52-.16-1.34-1.22.07-.07,0-.41.2-.16.65.8.85.69,1.21,1.08.03.02.15.07.26.18.35.36.39,1.2.73,1.66.07.09.17.16.13.01-.22-.98-.34-.79-.63-1.77-.05-.15.23.03.25.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m73.35,43.76c.37.83.38.83.62,2.01-.17-.03-.19-.05-.21-.14-.26-.81-.5-.84-.85-1.43-.03-.03-.3-.21-.37-.25-.46-.25-.59-.1-1.32-.78.03-.05.03-.42.17-.24.37.54.41.38.74.58.02,0,.34.06.43.1.33.1.75.72.89,1.06,0,0,.16.05.06-.16-.35-.66-.05-.33-.48-.9-.05-.07.31.1.33.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m72.25,43.97c.41.57.44.55.78,1.43-.13,0-.15-.03-.17-.07-.52-.55-.61-.53-.93-.97-.01-.02-.2-.16-.26-.18-.38-.13-.69-.06-1.35-.47.03-.05.11-.32.23-.2.36.38.49.24.77.35.01,0,.16,0,.22.02.33.04.69.58.91.78,0,0,.12,0,.02-.15-.37-.47-.03-.09-.43-.48-.05-.04.18-.09.21-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m75.34,41.94c.09.23.34.67.35.83-.19,0-.76-.67-.86-1.09-.04,0,.49.09.5.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m73.96,41.77c.09.23.26.71.53,1.09-.18,0-.78-.72-.87-1.13-.04,0,.29,0,.34.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m72.9,42.11c.13.2.4.56.64.97-.31-.06-.71-.57-.94-.91-.04,0,.24-.09.29-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m71.9,42.67c.05.19.26.37.63.69-.24,0-.75-.36-.93-.65.02-.01.25-.07.3-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.96,43.25c.03.1.14.2.35.38-.14-.01-.48-.12-.57-.28,0-.01.19-.1.22-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.92,47.11c.03.35.12.48.13.53.15.32.19.46.39.7.08.08.12.09.28.07.12-.02.03-.41.03-.63-.04,0-.08-.05-.14-.07-.02.06.08.35,0,.49-.01-.01-.04,0-.05,0-.16-.07-.21-.23-.25-.26-.13-.19-.21-.41-.26-.64-.01,0-.16-.19-.14-.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.05,48.01c-.22,0-.64-.02-.73-.02-.22,0-.29.01-.43.11-.06.04-.17.12,0,.19.04.09.63.01.88.07,0-.02-.02-.06,0-.1-.03-.03-.52-.07-.62-.07-.01,0-.07.02-.07-.07,0-.02.06-.04.08-.06.13-.01.51-.02.75.06,0-.01.14-.15.14-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.99,47.24c-.1,0-.29.03-.31.04-.17.1-.1,0-.19.1-.04.04-.12.1-.09.34.05.15.5.06.76.17,0-.04.04-.04.06-.1-.03-.05-.5-.1-.6-.12-.06-.08-.03-.02-.03-.14,0-.02.03-.06.05-.09.13-.01.12-.03.39-.06,0-.01-.04-.16-.05-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.88,47.07c-.07-.02-.4-.13-.4-.13-.1-.07-.08-.04-.12-.11-.02-.03-.17-.24-.15-.3.13-.12.25.06.45.04-.01.01.03.06.02.11-.02.03-.07,0-.14-.01-.16-.02-.1-.01-.05.1.01,0,.08.05.09.08.08.04.09.03.26.1,0,.01.03.14.04.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.86,47.6c-.13.02-.32.19-.34.2-.27.23-.37.3-.53.55-.05.09-.08.32.08.32.05.1.85-.25,1.05-.31,0-.04-.04-.08-.07-.15-.07,0-.67.3-.79.28,0-.02-.04-.08-.03-.09,0-.17.11-.21.13-.25.15-.16.31-.26.52-.38,0-.01,0-.2-.01-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.81,46.41c.02.25.22.57.24.6.14.22.21.27.39.43.08.06.13.07.29.06.11-.02,0-.35-.01-.5-.04,0-.08-.05-.15-.07-.02.04.04.19.05.37-.03,0,.04.08-.08.03-.14-.05-.18-.14-.21-.16-.12-.13-.23-.42-.28-.59-.01,0-.26-.17-.23-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.47,47.85c-.04-.09-.06-.22-.07-.32-.05-.03-.1-.09-.14-.12l.02.17s.04.13.06.13c.02.05.12.16.13.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.48,48.28c.09-.06.41-.19.52-.22q-.02-.07-.03-.12c-.1,0-.17.02-.24.08,0,0-.11.07-.11.09-.05.02-.14.15-.13.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.38,47.65c-.48.11-.48-.09-.57-.09,0-.05-.03-.02-.02-.07.09-.02.23.05.32.04,0,0,0,.05.26.07.06,0,.03.03.02.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.46,47.4c-.05-.14-.04-.19-.05-.28,0-.19.25-.42.3-.41.03.06-.04.18.03.39.02.07.16.06.11.19-.16.18-.37.2-.39.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.57,48.32c.1.04.13.06.2.07.13.01.25-.13.25-.17-.04-.03-.21.03-.28-.06-.03-.02-.16-.02-.25.01-.15.11.02.13.09.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.3,48.47c.06.04.09.05.14.07.1.01.18-.09.19-.11-.04-.02-.17.02-.21-.05-.01-.02-.11-.03-.18-.02-.11.07,0,.1.06.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.01,48.63c.06.04.08.04.11.06.09.02.16-.08.17-.1-.02,0-.14.01-.17-.04-.01-.02-.1-.03-.16,0-.1.06,0,.08.04.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.18,47.99c-.22-.27.06-.4-.3-.8-.02-.17.02-.15.06-.21.07-.07.3-.1.38-.19-.05.12-.27.51.15.86.01.01,0,.16.06.44-.07-.02-.11.02-.16,0-.09-.02-.18-.08-.2-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.25,48.3s0-.1-.02-.11c-.17-.1-.36-.25-.31-.73-.11-.13-.1-.22-.15-.24-.09-.03-.17.21-.17.28.11.07.16.2.23.56,0,0,.04.08.2.26.07.03.14-.03.21-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.91,48.48s.02-.07-.04-.15c-.08-.11-.17-.18-.22-.51-.08-.11-.11-.17-.15-.18-.07-.03-.1.17-.1.23.09.06.47.45.18.43-.08,0,.12.11.18.16q.07.03.13.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.44,47.01c-.04-.07-.06-.15-.07-.23-.04-.02-.09-.06-.14-.07v.12s.04.08.07.08c.02.05.12.12.14.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.92,46.91c.1.05.16.06.18.24-.05.23-.34.39-.65.81-.04.06-.15.03-.19.03-.14-.07-.29-.07-.35-.22,0-.01.02-.05.02-.06.12-.11.28.01.41,0l-.04-.2c-.03-.07-.18-.09-.32-.09-.09.04-.25.16-.31.27-.05.09.03.29.07.28.08.09.4.26.57.28.06,0,.2.05.36-.13.06-.25.58-.44.63-.94.01-.11-.01-.14-.04-.26-.04-.07-.21-.18-.28-.19l-.07.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m59.56,44.19c.39.1.75.46.79.6.17.51-.21,1.09,0,1.48.22.42.67.24,1.13.75.43.45.03.68.79.95.04.04.09.11.14.18-.66.06-.81-.36-1.03-.95-.21-.48-.85-.27-1.22-.84-.11-.58.15-.93.07-1.4,0-.34-.65-.62-.76-.63-.06,0,.09-.09.1-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m59.3,44.54c.39.1.51.35.56.46.19.5-.29,1.05-.11,1.43.21.41.61.46,1.25.89.5.34.07,1.65,1.62,1.23.05.06.18.14.22.21-1.47.64-1.72-.67-1.94-1.26-.47-.35-.94-.32-1.32-.89-.23-.82.22-.96.14-1.43,0-.32-.29-.5-.39-.49-.06,0-.03-.12-.03-.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m59.37,44.11c-.12.17-.3.3-.19.63.01.01.07.15.08.17-.06,0-.21-.02-.28-.03-.04-.34-.2-.45.13-.81.14-.06.19,0,.27.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m58.95,44.02c-.1.17-.3.3-.18.63,0,.01.07.15.08.19-.07,0-.21-.03-.28-.05-.04-.34-.21-.45.12-.8.14-.06.19,0,.27.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m58.54,43.97c-.12.17-.31.31-.19.62,0,.01.07.15.08.18-.08.08-.21-.02-.28-.05-.1-.22-.23-.29-.22-.44,0-.08.22-.22.35-.37.13-.05.19,0,.27.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.13,49.47c-.09.02-.25.04-.34.12,0-.01-.02.66.14.59.07-.03.14,0,.18-.09.06,0,.02-.39.1-.39,0-.04.23-.07.32-.08.14-.01.29-.16.29-.12.04,0,.13-.01.19,0-.16.14-.38.53-.56.55-.05,0-.2.14-.2.19.01.14.16.32.28.44.09.03.33.02.44-.29.11-.06.46-.63.57-.64.03-.06.18-.09.32-.07.25.01.25.19.32.2,0,.11.09.22.43.22.55-.12.57,0,.7-.39.2-.28.1-.26.04-.39-.09-.09-.21-.16-.34-.18-.45.08-.64-.01-.76-.24,0,0-.13,0-.23,0,.15.2.23.31.47.37.06.05.35,0,.4.14-.05.27-.16.32-.19.32-.23.03-.27-.16-.34-.21-.07-.05-.51-.3-.53-.36,0,0-.1.25-.31.25-.11,0-.61.73-.73.85-.14,0-.22-.04-.14-.09.09-.1.49-.59.54-.65.02-.09,0-.12-.03-.17-.03-.05-.08-.06-.15-.06-.29.03-.77.28-.87.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.62,49.65c0,.18.04.38.1.58-.08,0-.18,0-.27.04-.1.05-.21.21-.06.34l-.05-.03c-.22-.04-.39-.31-.19-.64.05-.11.39-.3.48-.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.14,50.36c.08.17.17.28.31.42-.13.11-.29.47.02.51-.01,0-.16.04-.16.04-.21.07-.49-.11-.48-.47,0-.11.22-.46.3-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m72.57,49.56c-.13.14-.18.23-.21.43.15.07.38.42.08.52.01,0,.17,0,.17,0,.22.03.45-.21.38-.55-.02-.11-.34-.39-.42-.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m74.12,49.37l-.03-.33-.24.27-.07.16-.31.26-.16-.29v.4c.02.17-.11.5-.14.6-.12.37-.47.39-.71.33v.16c1.11.14.67-.66,1.14-1.03,0,0,.04-.08.06-.1.23-.2.68-.29.86-.22.05.03.07-.15.11-.15,0-.07-.43-.08-.51-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m75.33,50.48h.37c-.16.09-.31.11-.47.2-.18.14-.17.23-.57.44l.31.21c-.18-.02-.45-.04-.56-.04-.21.3-1.36.2-1.35.23l.03.35c0,.06-.21-.33-.44-.38-.22-.06-.56-.06-.58.02l.14-.25c.88-.02,1.3.2,2.19-.23.39-.19.71-.6.7-.77,0-.04.14-.04.2-.09.09.03.11.24.03.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m73.86,50.79c-.17.02-.35-.03-.45.02-.17.22.11.27.19.2l.27-.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m73.88,50.02c-.09.14-.25.24-.29.34.05.28.27.11.28.01l.02-.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m74.45,50.06c-.12.13-.28.22-.32.31.01.28.25.12.27.04l.05-.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m74.51,50.68c-.14.01-.29-.02-.37.01-.15.18.08.22.15.17l.22-.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m59.7,50.05c-.14.04-.2-.04-.33-.03.1.27.2.33.4.25.17.15.17.25.56.46-.1.07-.22.14-.32.2.16.09.44.08.55-.02.07.1.27.18.46.21.1.03-.24.31-.19.32.23,0,.37-.07.44-.27.04,0,.75.03.75.03.03-.08,0-.1.01-.24-.89-.06-.64.14-1.46-.31-.35-.18-.61-.6-.62-.76-.02-.17.46-.73.6-.76.21-.08.4.06.73.23.29.15.66.77.77,1.08l.18-.16c-.1-.26-.12-.36-.16-.44-.06-.08.18-.27.01-.63-.07.11-.14.22-.21.33-.19-.23-.51-.46-.94-.66,0-.19-.13-.34-.42-.47l.08.46c-.47,0-1.06,1.08-.91,1.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m61.34,50.46c.17.03.35,0,.45.04.17.22-.12.26-.2.2l-.25-.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m61.3,49.63c.1.15.25.25.27.36-.06.28-.27.08-.28-.01v-.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m60.7,49.48c.1.12.26.23.29.32-.02.27-.25.11-.26.01l-.03-.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m60.59,50.16c.14.05.29.06.36.11.09.21-.14.18-.18.12l-.18-.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.94,52.08c-.09.14-.05.1-.19.19.18.02.33-.03.5-.19.24.01.59-.03.77-.01.04.13-.01.14-.06.28.21-.04.37-.13.41-.29.14.05.44-.02.64-.13.1-.06.04.31.06.28.19-.16.31-.2.24-.44.02-.01.35-.12.35-.12-.02-.08.03-.17-.04-.32-.87.51-1.23.47-2,.47-.17,0-.71-.05-.89-.13-.35-.17-.19-1.02-.11-1.14.14-.22.23-.38.81-.41.37-.02,1.11.32,1.44.51l.04-.27c-.27-.16-.36-.24-.45-.27-.1-.03-.03-.37-.44-.56.01.14.04.28.05.43-.17-.03-.49-.11-.64-.08-.05-.19-.4-.29-.58-.29,0,0,.17.31.1.33-.08.02-.2.13-.27.15-.21-.05-.2-.13-.54-.03l.29.32c-.31.38-.36,1.72.51,1.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.09,50.9c.18,0,.37-.07.48-.04.2.2-.08.28-.17.23l-.31-.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.89,51c.17-.05.34-.16.45-.17.25.14,0,.31-.09.29l-.36-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.73,50.35c.17.06.38.05.47.11.13.28-.17.26-.24.18l-.23-.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.07,50.8c.18-.05.36-.17.47-.16.27.14,0,.31-.11.27l-.36-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.54,51.43c.16-.05.32-.17.42-.17.25.12.01.27-.08.26l-.33-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.41,51.47c-.02.18-.09.34-.28.33.22.2.36,0,.51-.16.21.05.43.15.88.16-.05.1-.09.21-.15.33.25-.04.44-.19.43-.29.15.09,1.3-.27,1.24-.34-.03-.05,0-.1-.05-.24-.82.32-.61.31-1.53.33-.37.01-.82-.25-.9-.39-.1-.14.06-.87.16-.95.14-.16.57-.11.54-.17,0,0,.04-.26,0-.24-.1.05-.22.04-.4.06-.09-.17-.1-.19-.41-.17.1.09.14.19.21.28-.41.23-.42,1.46-.25,1.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.47,50.97c.17-.03.34-.13.45-.13.23.16-.03.29-.12.25l-.32-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.51,50.16c.17.04.65.29.66.42-.02.04-.06.13-.12.13-.15-.14-.34-.28-.57-.32l.03-.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.92,50.76c.16-.04.32-.13.42-.12.23.16-.02.28-.11.25l-.31-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.5,51.25c.14,0,.3-.05.37-.02.17.16-.06.22-.13.18l-.24-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.83,49.78v-.16c-.26-.02-.41.13-.37.49.04.34.11.51.32.6.22.09.48-.02.55-.51.08-.48-.16-.57-.49-.58l-.02.16c.11.01.22.18.2.37-.02.18-.13.36-.24.35-.11-.01-.17-.2-.16-.38,0-.17.1-.31.2-.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.36,49.28c.06-.1.17-.15.29-.13.07.13.1.24.06.37-.04,0-.07.02-.1.03-.11-.05-.19-.15-.24-.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.84,49.09c.1-.07.21-.07.34,0,.01.14-.01.25-.09.36-.04,0-.07,0-.12,0-.08-.1-.12-.22-.13-.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.3,49.18c.12-.02.22.03.3.14-.06.13-.14.22-.25.28-.03-.02-.06-.04-.1-.06-.02-.12,0-.24.05-.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m75.43,49.32l.18-.16c-.14-.12-.44-.07-.65.11-.25.2-.35.5-.21.66.12.14.45.14.69-.06.26-.19.31-.55.17-.7l-.17.16c.07.09.03.3-.12.41-.14.12-.36.14-.44.05-.07-.1.01-.28.16-.39.13-.11.31-.14.39-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m75.47,48.5c.11,0,.2.04.26.13-.06.13-.13.2-.23.25-.04-.02-.06-.03-.09-.05-.02-.11,0-.23.05-.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m75.84,48.73c.11,0,.19.07.25.18-.07.1-.16.17-.28.19-.01-.02-.04-.04-.08-.06.01-.12.04-.23.12-.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m76.24,49.1c.08.08.1.17.05.3-.12.02-.23.02-.33-.04v-.09c.07-.09.16-.15.28-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m76.26,48.35c-.09.04-.17.11-.23.21.04.07.1.12.18.16.09-.06.14-.12.2-.21.1.06.23-.06.27-.16.05-.11.01-.25-.11-.3-.11-.05-.25,0-.29.11-.02.05-.04.12-.02.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m59.39,48.33l-.12-.11c.2-.21.44-.22.64.07.19.28.26.44.15.67-.12.23-.4.34-.79.05-.39-.3-.27-.55-.01-.8l.13.11c-.09.09-.04.3.09.42.14.12.36.16.44.07.08-.09,0-.28-.13-.4-.13-.11-.3-.15-.39-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m59.59,47.53c-.1-.05-.21-.03-.32.05.01.14.06.25.16.33.03-.02.07-.02.11-.02.06-.11.09-.24.05-.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m59.07,47.7c-.12,0-.21.07-.27.18.07.13.16.2.29.24.03-.03.06-.05.09-.07,0-.13-.04-.25-.1-.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m58.58,48.04c-.09.08-.13.18-.1.31.14.06.26.06.37.02,0-.04.02-.07.03-.11-.07-.11-.17-.19-.3-.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m58.67,47.29c.1.05.16.13.21.23-.04.06-.1.12-.18.15-.09-.05-.14-.13-.19-.21-.12.05-.24-.07-.27-.18-.03-.12.01-.25.13-.3.11-.03.24.03.29.13.02.06.04.13,0,.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.62,51.81c-.08.18-.22.32-.24.44.1.29.3.04.29-.06l-.06-.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.44,50.94c-.16.11-.37.17-.45.25-.07.32.24.22.29.12l.16-.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m71.39,50.18c-.2.05-.43.04-.54.1-.18.3.18.31.26.22l.28-.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m71.34,50.93c-.2.02-.42-.04-.54,0-.23.25.11.33.22.26l.32-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.57,50.15c-.13.11-.31.17-.37.26-.03.3.22.18.26.08l.11-.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.95,49.77c-.11.02-.23,0-.29.03-.12.16.06.17.11.13l.18-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.06,51.51l-.27-.21c-.16.57,0,1.26.19,1.93.29-.01.81-.09,1.2-.16-.13-1.02.29-1.05.97-1.32.15.02.8-.03.79-.03-.03-.05-.19-.11-.24-.22-.05-.14.25-.31.3-.36.35-.28.38-.72.28-1-.01-.01-.03-.02-.03-.05-.08.06-.21.08-.3.15.13.4.1.53-.61,1.09-.22.18-.94.47-1.1.58-.37.25-.33.54-.33.97,0,.02-.8.07-.8.05-.05-.56-.31-.9-.06-1.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.88,53.36c-.11-.01-.24-.16-.24-.3,0-.16.14-.22.23-.19.09.03.18.02.17.15,0,.06.17.03.17-.03,0-.22-.15-.35-.33-.34-.19,0-.43.08-.45.34-.01.12.08.33.14.4-.04.57-.01.77.26,1.2-.05.08,0-.01-.03.09-.03.1-.05.28.03.41.16.25.38.23.55.15.18-.08.25-.32.17-.52-.05-.1-.21-.04-.16.06.06.12,0,.19-.08.25-.09.07-.23.07-.3-.08-.05-.15.04-.29.12-.36-.19-.2-.44-.85-.25-1.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.97,52.85c.09-.06.14-.27.11-.39-.05-.14-.2-.14-.29-.09-.08.06-.14.13-.1.24.03.1-.19.16-.23.06-.08-.18.08-.43.26-.48.17-.06.48-.04.58.17.05.12.04.38-.07.43.24.49.26.64.15,1.1.09.05.05,0,.1.06.06.08.14.24.11.37-.05.27-.27.33-.46.32-.19,0-.34-.2-.34-.4.01-.11.18-.11.18,0-.01.12.07.14.17.16.1.03.19-.03.19-.19,0-.16-.11-.27-.21-.29.11-.24.15-.8-.15-1.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.61,52.78c-.41-.01-.86.08-1.24.19,0-.05-.06-.13-.04-.25.39-.12.84-.17,1.24-.19,0,.05.03.2.04.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.69,54.98c.83.39,2.78-.1,3.13-.33,0,.05.23.03.19.15-.43.46-3.18.73-3.39.48,0-.05.06-.26.07-.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.92,53.13c.82.72.56,1.19,1.34,1.77-.06,0-.14,0-.19.03-.86-.68-.71-1.26-1.48-1.83.06-.03.27-.09.33.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.55,52.99c.74.68.55,1.23,1.32,1.83-.06,0-.15.07-.26-.05-.8-.71-.63-1.2-1.39-1.78.06-.03.18-.04.32,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.48,53.42c.29.14.23.8.95,1.29-.05,0-.1.05-.18-.03-.65-.44-.5-.69-.99-1.25.05-.02.13-.04.23,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m73.23,53.71v.22c.26-.02.38-.12.39-.44,0-.26-.14-.43-.35-.44-.21-.02-.4.05-.44.34-.05.28.17.53.4.54v-.2c-.09-.03-.19-.11-.19-.28-.01-.15.12-.22.22-.18.11.03.19.09.17.24-.02.13-.08.2-.2.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m74.4,51.84c-.35-.05-.61-.05-.95.12-.24.22-.11.49.12.54.4.07.6.03.95-.34-.23,0-.57.03-.79,0,.01.01-.06.14.03.21-.06,0-.12.04-.16-.04-.23-.45.51-.35.86-.34,0-.01-.05-.14-.06-.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m71.59,52.66c.51-.08,1.06-.24,1.52-.43,0,.05,0,.08.02.12-.46.21-1.03.38-1.54.49,0-.05,0-.13,0-.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m71.89,54.17c.27-.18.57-.33.84-.41v-.14c-.26.01-.63.13-.92.31.02.04.07.21.08.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m72.68,53.24c-.53-.01.19-.44.64-.64-.03-.03-.05-.07-.07-.1-.63.19-1.65.86-.58.91.04.03-.02-.2,0-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.36,55.12c.28-.23.5-.36.89-.37.31.07.34.4.15.56-.3.28-.5.33-.99.18.19-.11.52-.28.69-.41,0,.03.12.11.08.21.05-.02.12-.01.12-.12-.03-.54-.62-.05-.91.13-.01-.01-.03-.15-.03-.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.86,52.56l-.02.22c.26-.02.4-.12.39-.44.01-.27-.14-.43-.34-.45-.22,0-.4.06-.45.34-.03.29.18.54.4.55l.02-.22c-.1-.02-.19-.11-.21-.27,0-.16.14-.22.23-.19.1.04.19.1.17.25-.02.13-.08.2-.2.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.23,54.37v.22c.26-.02.38-.12.39-.44,0-.26-.14-.43-.35-.45-.2,0-.4.06-.45.34-.03.29.18.54.41.55v-.22c-.09-.01-.19-.1-.19-.27-.01-.16.12-.22.22-.18.11.03.19.09.17.24-.02.13-.08.2-.2.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m61.5,52.4c.36-.04.61-.03.94.16.24.22.09.5-.14.53-.41.06-.6,0-.94-.38.22,0,.57.05.8.03-.02.01.04.14-.04.21.05,0,.11.05.15-.03.26-.44-.49-.37-.84-.39,0-.01.06-.13.07-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.88,52.95c.09.35-1.78-.38-2.12-.27-.03.05.01.11.01.14.66-.01,2.32.83,2.29.16,0-.05-.18.02-.18-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.22,53.25c-.31-.1-.71-.38-.95-.52-.03.03-.03.08-.06.1.09.28.66.59,1.04.59.03-.03-.05-.14-.03-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.52,55.12c-.3-.15-.52-.17-.83-.05-.02-.03-.04-.13-.05-.16.24-.18.57-.21.88,0,.02.05,0,.18,0,.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.62,53.64c.1-.23-.39-.41-.95-.51.02-.04.05-.09.07-.13.66.07,1.58.49.99.8-.02.04-.09-.2-.11-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.46,54.66c.66-.55-1.11-.61-1.6-.52,0-.04-.02-.11-.03-.14.68-.18,2.58-.02,1.78.77-.02.04-.13-.14-.15-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.76,55.67c.11-.02.19-.03.3-.04-.02.34.08.69.2,1.03-.08,0-.2,0-.28.01-.13-.31-.19-.64-.23-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.86,56.76c.1.15.15.15.3.15-.34.3-1.04.71-1.06,1.24-.09-.08-.12-.22-.22-.29.06-.39.63-.73.98-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.66,56.76c.08.05.09.02.27.01-.2.4-.82.88-.93,1.36-.09-.08-.09-.22-.18-.3.05-.4.51-.71.85-1.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m71.49,57.2c-.02.1-.27.05-.2.21-.45-.03-.78-.41-1.26-.33.02-.12.06-.16.08-.27.39-.11.9.22,1.37.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m71.15,56.42c-.02.1-.22,0-.14.17-.46-.02-.43-.26-.91-.18.02-.12.08-.16.11-.29.39-.1.47.12.94.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.77,56.88c.05.09.24-.05.2.13.43-.15.3-.39.79-.45-.07-.1,0-.16-.06-.26-.4,0-.51.28-.93.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m71.47,56.6c0,.06-.04.04,0,.17-.16-.04-.17-.07-.34-.03,0-.08,0-.11,0-.19.08-.07.16-.09.35.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m67.47,57.16c.02.08.06.04.07.19.16-.09.17-.12.36-.13-.03-.11-.01-.12-.04-.21-.11-.05-.21-.05-.38.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.74,57.66c-.03.1-.27.03-.2.19-.46-.03-.44-.32-.92-.24.04-.12.16-.12.18-.23.39-.11.47.11.94.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.88,55.57c-.11,0-.2,0-.31.02.08.33.06.69-.01,1.05.08,0,.2-.04.28-.04.07-.33.07-.67.04-1.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m68.59,55.74c.02.09.03.1.05.2-.36.02-1.07.52-1.25.74-.01-.02-.28-.41-.38-.52l-.07.25-.41.03-.65-.52.19.58-.26.04-.86-.46.32.47-.36.06-.85-.26.27.3-.69.28,1.34-.19-.31.59.59-.49.68-.09-.35.73.63-.76.52-.07-.11.6.48-.75.14-.06.14.22-.76.86-.24.05.16-.65-.28.07-.5.68h-.4s-.08-.2-.08-.2l.36-.51-.35.1-.53.41-.44.02.36-.55-.57.09-.05.12-.78.02.05-.27.58-.39-.13-.19.33-.17.85.22-.4-.48.5-.07.73.44-.21-.67.37-.05.65.62.12-.31.3.03.37.22c.29-.16.86-.32,1.21-.39h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "63.63 56.13 62.77 55.61 62.64 54.95 62.4 54.92 62.34 55.21 62.19 55.04 62.07 54.34 61.55 54.01 61.56 54.72 61.29 54.43 61.18 53.69 60.81 53.49 60.8 54.02 60.34 53.59 60.19 53.78 60.35 54.09 60.43 54.2 59.91 54.31 59.8 54.5 60.17 54.55 60.67 54.88 59.86 54.93 60.19 55.23 61.15 55.34 61.27 55.52 60.43 55.79 60.99 56.13 61.84 55.93 61.89 56.22 63.04 56 62.76 55.85 62.08 55.95 62.06 55.7 61.14 55.9 60.99 55.82 61.54 55.65 61.69 55.45 61.2 55.1 60.49 55.07 61.08 55.02 60.99 54.65 60.31 54.43 60.61 54.35 60.57 54.06 60.98 54.51 61.03 53.93 61.16 54.69 61.76 55.22 61.75 54.42 61.94 54.66 62.06 55.42 62.38 55.64 62.54 55.28 62.63 55.75 63.53 56.28 63.63 56.13 63.63 56.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.79,56.04c-.13-.19-.24-.41-.09-.58.02-.05.03-.1-.04-.18-.15.03-.27.03-.49.17-.08.07-.1.19,0,.23.32.05.39.36.62.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.4,56.42c-.21.03-.46.08-.49.31-.03.05-.06.09-.16.09-.08-.12-.17-.22-.19-.48,0-.11.06-.21.17-.16.25.22.52.07.67.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m63.29,55.28c.1,0,.17-.1.16-.2,0-.11-.1-.18-.2-.17-.11,0-.18.1-.17.21,0,.1.1.17.21.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.22,56.75c-.07-.08-.04-.2.04-.26.09-.06.2-.04.26.05.07.08.04.19-.04.26-.09.06-.2.03-.26-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m59.94,53.8c-.06-.21-.1-.46.1-.56.03-.05.05-.1.02-.19-.15-.02-.27-.06-.52.01-.09.03-.15.15-.08.21.29.15.26.47.47.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m59.67,54.26c-.22-.04-.47-.06-.56.15-.04.04-.09.06-.18.03-.05-.14-.1-.26-.05-.51.04-.1.14-.17.21-.09.18.27.49.22.58.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m59.8,52.58c-.1-.03-.2.04-.23.14-.03.1.04.2.14.22.1.03.2-.03.22-.13.03-.1-.03-.2-.13-.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m58.42,54.21c-.02-.09.03-.19.12-.23.11-.03.21.02.24.12.02.09-.03.19-.12.23-.11.03-.21-.02-.24-.12h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "60.11 54.15 60.06 53.94 59.83 53.93 59.27 53.36 59.26 52.29 59.06 52.12 58.81 52.53 58.74 51.32 58.37 51.27 58.19 51.97 58.04 51.9 57.97 51.15 57.75 51.09 57.64 51.58 57.24 51.19 57.08 51.26 57.18 51.38 56.75 51.46 57.09 51.8 56.52 51.91 56.77 52.21 57.54 52.31 57.77 52.44 56.99 52.49 57.12 52.84 57.6 52.95 58.11 52.99 58.31 53.11 57.81 53.17 57.84 53.33 58.31 53.51 59.31 53.79 59.07 53.49 58.31 53.28 58.69 53.2 58.38 52.84 57.36 52.66 58.18 52.57 57.72 52.15 56.95 52.03 57.51 52.01 57.12 51.58 57.41 51.67 57.32 51.46 57.67 51.82 57.82 51.48 57.89 52.07 58.36 52.38 58.55 51.52 58.61 52.56 58.72 52.9 59.06 52.53 59.05 53.45 59.32 53.81 59.73 54.12 60.11 54.15 60.11 54.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m57.45,50.87c.03-.22.08-.46.32-.49.04-.04.08-.08.07-.17-.13-.07-.22-.16-.47-.18-.11,0-.21.08-.15.17.22.26.07.53.24.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m56.84,51.12c-.18-.13-.4-.26-.57-.1-.06,0-.11,0-.17-.07.02-.15.04-.27.2-.47.06-.08.2-.09.22.02.04.32.35.4.34.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m57.76,49.68c-.08-.05-.2-.03-.25.05-.06.09-.04.21.05.26.08.05.2.04.25-.05.06-.09.04-.2-.05-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m55.75,50.54c.01-.1.1-.17.2-.15.1.01.18.1.16.21-.01.1-.12.17-.21.15-.1-.02-.17-.1-.15-.21h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "57.24 51.06 56.84 50.21 56.96 49.87 56.93 49.69 56.71 49.74 57.15 49.28 57.12 48.83 56.55 49.1 56.67 48.88 57.14 48.33 57.16 47.93 56.58 48.3 56.63 48.08 56.89 47.74 56.74 47.36 56.55 47.45 56.31 47.74 56.2 47.47 55.92 47.7 55.98 48.48 55.55 48.1 55.45 48.57 55.93 49.27 55.36 49.18 55.45 49.6 55.78 49.67 56.13 49.88 56.11 50.09 56.67 50.42 56.66 50.18 56.29 50.01 56.38 49.79 55.71 49.46 56.22 49.51 56.18 49.22 55.64 48.48 56.14 48.86 56.12 47.75 56.27 48 56.64 47.73 56.33 48.25 56.36 48.67 56.82 48.37 56.32 49.03 56.43 49.34 56.93 49.21 56.51 49.65 56.6 49.95 56.81 49.93 56.66 50.18 56.68 50.42 57.08 51.08 57.24 51.06 57.24 51.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.04,55.61c.37-.05,1.14.11,1.47.22.46.09,1.41-1,2.98-1.24v.02s.11,0,.14.02c-.87.13-1.28.8-2.54,1.22-.06.1.03.06.07.09.98.05,1.39-.63,2.36-1.12.02,0,.15-.09.33-.04-.39.44-1.6,1.37-2.63,1.48-.35.02-1.66-.45-2.19-.42,0-.08,0-.1,0-.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m73.94,54.23c-.07-.05-.21-.06-.31-.06-.34.09-.63.31-.92.41-.49.17-.68.56-1.14.95-.13.01-.24,0-.38.01,0,.08.13.12.15.14.14.06.32.08.43-.02.8-.57,1.54-.94,2.36-1.19-.06-.02-.12-.04-.18-.04-.1-.07-.6.13-1.82.79,0-.01.02-.03,0-.04.36-.26.37-.41.66-.48.35-.09.85-.46,1.14-.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m74.75,55.55c-.08-.05-.15-.11-.25-.11-.44.13-.56.48-1.53.82-.05,0-.18.11-.34.14-.17.03-.38.05-.45.05,0,.08.07.09.2.16.14.05.2.05.28.07.89.17,1.7-.75,2.53-1-.06-.02-.12-.04-.19-.05-.52-.05-1.63.97-1.94.84,0-.02-.12-.05.02-.09.38-.08,1.01-.68,1.68-.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m75.57,54.61c-.09-.05-.19-.08-.3-.09-.04.06-.06.15-.05.23.09.05.17.07.27.08,0,.12.16.18.28.17.12-.02.22-.12.21-.25-.01-.12-.13-.22-.24-.21-.06,0-.14.03-.17.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m74.61,53.73c-.01.11,0,.2.04.31.04,0,.05.1.08.1s.11-.13.15-.16c.01-.1-.02-.18-.05-.27.1-.06.09-.22.02-.33-.06-.09-.19-.15-.31-.08-.1.07-.14.22-.07.31.03.05.07.11.13.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m74.83,54.41c.12-.35.26-.46.63-.62.84-1.46,1.32-1.59,1.94-2.48.05.26-.07.32-.09.36-.37.59-.67.41-1.49,1.82,0,.13.06.04.11.05.84-.82,1.41-1.42,1.67-2.09.09.18.09.4-.15.75-.37.55-.77.9-1.32,1.44-.26.31-1.14.5-1.07.89-.11,0-.12-.05-.24-.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m76.45,51.18c-.27.55-.63.82-.77.92-.57.5-.25.96-.35,1.5.13-.1.04-.21.24-.31.45-.81.35-.55.82-1.15.08-.09.17-.51.05-.41-.77,1.18-.88,1.16-.88,1.28-.01-.02-.17.14-.06-.09.01-.61.33-.69.36-.73.32-.31.36-.42.53-.63.1-.1.06-.35.06-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m77.88,52.07c-.39.67-1.24,1.49-1.4,1.61-.05.03-.05.08-.13.13-.11.11-.44.22-.5.26.03.07.21.02.35.04.14,0,.18-.02.27-.04.33.07.64-.2.98-.55.26-.28.5-.59.69-.95.01-.01.03-.23,0-.34-.41.86-.94,1.14-1.33,1.55-.09.06-.27.04-.11-.1.68-.54.75-.72,1.09-1.3.03-.05.04-.27.08-.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m78.55,51.1c-.1-.01-.2,0-.31.04,0,.07,0,.16.05.24.11.01.19,0,.29-.04.05.1.21.09.31.03.1-.06.15-.19.09-.31-.06-.1-.21-.15-.31-.08-.05.02-.1.07-.12.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m77.15,50.66c.03.1.09.18.18.26.02-.01.08.08.1.06.05-.03.06-.16.09-.21-.04-.09-.1-.16-.16-.22.08-.09-.01-.24-.11-.3-.1-.06-.24-.05-.32.05-.06.1-.04.24.06.31.04.03.11.06.16.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m77.69,51.34c-.02-.37.06-.52.33-.81.03-1.72.67-2.71.82-2.72-.43.82,0,.42-.57,2-.08.39.14.19.17.18.34-.49.48-1.66.61-2.58.15.12.25.47.18.86-.12.66-.14,1.37-.63,1.85-.12.4-.86.92-.64,1.25-.11.03-.14,0-.27-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m78,47.82c-.39.82-.9,1.73-.15,2.5.1-.13.04-.21,0-.48.28-.86.5-1.99.47-1.94-.2.45-.38,1.06-.56,1.67-.01-.01-.14.28-.11.03-.04-.8.35-1.14.36-1.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m79.72,48.12c-.57.35-.24.78-.81,1.85-.12.14-.28.45-.41.62.05.05.2-.07.34-.1.13-.07.37-.25.45-.31.27-.46.72-1.58.58-2.02-.19.95-.52,1.68-.6,1.77-.36.27-.39.43-.15-.05.4-.78.31-1.33.6-1.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m79.63,46.97c-.11.02-.19.07-.28.13,0,.07.04.15.12.21.09-.02.17-.06.25-.13.08.1.24.03.32-.07.08-.09.07-.24-.02-.31-.09-.09-.24-.07-.31,0-.04.04-.09.12-.08.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m78.32,47c.06.09.13.14.25.19.02-.01.1.04.12.02.02-.04,0-.18,0-.23-.06-.08-.13-.12-.23-.17.05-.1-.08-.22-.19-.25-.12-.02-.25.04-.29.16-.03.11.05.25.16.27.05,0,.12.02.18,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m78.86,47.31c.09-.43.05-.54.12-.85-.47-1.46-.17-2.69-.03-2.74.24.76-.23,1.24.04,1.98.03.36.21.22.28.12-.23-1.97.11-.8-.11-2.13.37.06.4,1.98.2,2.31.01.37-.37.55-.32,1.23-.09.07-.06.05-.19.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m77.95,43.99c.11,1.61-.16,1.4.78,2.28.06-.13-.01-.24-.12-.47-.21-.58-.06-1.21-.32-1.34.14.43.02.65.14,1.25-.01-.01-.1.17-.13-.06-.32-.65-.05-.85-.36-1.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m79.72,44.07c-.16.52,0,.83-.12,1.89-.06.05-.33.56-.25.78.07-.17.17-.36.31-.45.11-.09.31-.18.37-.24.28-.51.12-1.67-.13-2.02.23,1.29.06,1.66,0,1.77-.27.33-.14.15-.12.03.19-.77.03-1.34-.06-1.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m54.88,45.73l.62-.02v.02s-.26.04-.26.04c-.06.02-.12.05-.17.09-.06.03-.1.09-.12.17-.02.07-.02.16-.01.27v.1s0,.13,0,.13v.02s0,.01,0,.01l.79-.03v-.13s-.01-.12-.01-.12c0-.05-.02-.08-.07-.1-.04-.02-.09-.04-.15-.05l-.17-.02v-.02s.84-.02.84-.02h0s-.14.04-.14.04h-.07s-.02.02-.06.02c-.02.01-.06.03-.08.06-.02.03-.03.06-.03.1v.25s.93-.04.93-.04v-.07s0-.1,0-.1v-.07c-.01-.18-.05-.31-.11-.37-.07-.07-.13-.11-.17-.13-.03,0-.05-.02-.06-.03-.01,0-.04,0-.06-.02h-.15s-.16-.03-.16-.03h.01s.71-.04.71-.04l.02.42.03.54v.42s-.03,0-.03,0v-.26s-.01-.01-.01-.01h-.02s-1.74.04-1.74.04c0,.05-.01.12-.02.22v.06s-.02,0-.02,0l-.05-1.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m55,44.77c.04-.08.11-.13.18-.17-.03-.07-.1-.12-.17-.18h.2s.25.03.25.03l.21.02c-.13.02-.22.04-.28.06-.06.02-.12.03-.19.08-.07.04-.12.11-.16.17-.05.08-.07.15-.08.22,0,.05,0,.11.03.18.02.08.06.13.12.17.07.03.11.04.15.05.04,0,.09-.02.15-.07.06-.05.12-.14.18-.25l.21-.33c.06-.11.13-.19.22-.25.08-.06.19-.08.31-.06h.07c.17.04.27.11.32.23.06.11.08.21.07.28-.01.12-.04.21-.08.27-.06.05-.1.11-.12.12l-.07.05s.05.07.11.11l.12.09-.74-.05v-.02c.16-.02.32-.05.44-.13.14-.06.22-.14.26-.23.04-.1.06-.16.06-.21.01-.11-.02-.2-.1-.29-.07-.08-.14-.12-.24-.12-.05,0-.11,0-.15.05-.04.04-.1.11-.16.2l-.21.33c-.07.13-.15.22-.24.29-.09.06-.18.09-.29.08-.07,0-.17-.03-.28-.08-.1-.05-.16-.18-.17-.36.01-.11.03-.2.07-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m56.04,42.82h.01s0,.01,0,.01h-.01c-.15,0-.25-.01-.31-.02h-.15s-.08.03-.14.05c-.05.02-.09.06-.12.1-.04.05-.06.1-.07.14v.04s-.03.07-.03.07l.53.12.69.16.53.12.07-.28h.03s-.18.78-.18.78h-.02s.06-.27.06-.27l-.53-.12-.69-.16-.53-.12v.05s-.03.05-.03.05c0,.04,0,.08,0,.13.02.05.04.09.09.15.03.05.08.09.13.13.06.03.13.07.21.1l.19.07v.02s-.75-.18-.75-.18l.3-1.31.74.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m56.06,41.55l.8.05.74.04.09-.21h.01s.01.02.01.02l-.09.21-.09.27-.09.21h-.01s-.01-.02-.01-.02l.1-.24-.18-.02h-.23s-.18-.03-.18-.03l-.19.51.17.13.17.14.03.02c.07.03.15-.05.22-.24h.04s-.22.58-.22.58h-.04c.06-.15.04-.25-.05-.32l-.45-.37-.6-.46-.31-.24v-.02s.02-.03.02-.03c.01-.01.02-.01.03-.02l.34.02h0Zm.54.26l-.35-.03h-.27s.21.15.21.15l.28.21.21.16.18-.47-.27-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m56.57,39.67c.04-.08.11-.13.18-.17.08-.04.17-.06.27-.07.1,0,.2,0,.32.04.11.03.21.06.31.12.1.06.19.11.26.17.06.05.13.12.17.18.05.07.08.14.1.21.03.07.04.15.02.26,0,.11-.04.22-.1.35l-.36.65-.03-.02.13-.24-.48-.27-.61-.34-.48-.27-.12.24-.03-.02.44-.8h0Zm-.17.38l1.56.86.11-.2c.05-.09.08-.18.08-.27,0-.1-.08-.2-.21-.32-.13-.11-.3-.22-.47-.32-.2-.13-.38-.18-.5-.21-.12-.01-.23,0-.28.05-.07.03-.11.08-.15.15l-.13.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m57.61,38.24c.09-.03.18-.04.28-.04.1.02.21.04.32.09.12.05.23.11.33.19.08.06.16.14.22.21.07.08.11.16.14.24.04.08.05.18.05.28,0,.11-.04.21-.1.3-.04.06-.1.12-.14.15-.03.03-.08.04-.14.05-.05.02-.14.01-.31,0-.16,0-.34-.09-.55-.25-.18-.14-.32-.31-.38-.52-.07-.21-.05-.39.08-.56.05-.07.12-.12.2-.14h0Zm-.25.37c0,.06.02.12.05.18.04.06.11.13.21.23.11.1.21.2.33.28.09.08.18.13.25.18.08.04.13.07.18.09.06.02.09.03.11.04.02,0,.05,0,.06,0h.05s.06-.02.11-.03c.05-.02.08-.04.12-.1.04-.05.06-.11.07-.17,0-.06-.01-.12-.03-.17-.02-.06-.04-.09-.07-.13l-.29-.24-.21-.17c-.21-.15-.36-.25-.46-.29-.1-.04-.18-.04-.25-.02-.06.02-.1.05-.15.1-.05.08-.07.14-.08.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m58.46,37.23c.08-.03.16-.04.25-.02,0-.07,0-.16-.02-.25l.15.14.2.17.14.13h-.01c-.11-.05-.2-.1-.25-.12-.05-.03-.11-.05-.19-.05-.08,0-.17,0-.25.04-.08.02-.15.06-.19.11-.03.04-.06.09-.09.16-.03.06-.02.13,0,.2.03.06.06.1.07.13.04.02.09.04.16.03.08,0,.18-.03.31-.08l.36-.13c.13-.04.23-.06.33-.04.1,0,.19.05.28.14l.05.04c.11.13.16.25.12.39-.04.12-.08.21-.13.26-.08.08-.16.13-.24.14-.07.02-.13.02-.17.03h-.08s0,.09.01.15l.04.14-.54-.5h.01c.14.07.28.14.42.16.15.03.27.02.35-.02.09-.04.15-.09.18-.12.08-.08.1-.17.11-.27,0-.11-.04-.2-.11-.27-.04-.03-.09-.05-.15-.05-.06,0-.14.01-.25.05l-.37.13c-.14.05-.26.07-.37.07-.11,0-.2-.05-.29-.13-.05-.04-.11-.12-.15-.24-.05-.1-.02-.24.1-.38.07-.08.14-.13.21-.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m61,35.14c-.17.11-.21.22-.14.33l.74,1.02c.08.1.09.21.04.32-.04.11-.11.2-.2.27-.07.04-.14.08-.22.12-.07.02-.14.04-.21.03-.06,0-.12-.02-.18-.04-.05-.03-.1-.06-.13-.12l-.81-1.13-.21.15h-.01s0-.02,0-.02l.62-.44v.02s-.21.17-.21.17l.9,1.24s.08.08.13.08c.06.02.12.01.18,0,.06-.02.1-.05.15-.07.08-.06.13-.12.17-.2.04-.06.06-.13.04-.2,0-.06-.03-.12-.08-.16l-.03-.06-.3-.4-.23-.31-.15-.23c-.08-.11-.19-.11-.32-.03l-.03.03h-.02s-.01,0-.01,0l.53-.37v.02h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m61.77,34.71l.39.29.49.36.39.28-.48-1.05c-.06-.11-.17-.13-.33-.05v-.02s.53-.25.53-.25v.02c-.16.09-.22.18-.18.27l.71,1.51-.03.02-.46-.34-.58-.44-.46-.34.59,1.26c.05.1.11.13.18.13.08,0,.13-.01.14-.03l.06-.02v.02s-.17.09-.17.09l-.23.11-.17.09-.02-.03.07-.03.06-.03s.05-.07.05-.11v-.12s-.03-.07-.04-.1c-.02-.06-.06-.15-.11-.24l-.47-1.01c-.03-.07-.13-.06-.3.03l-.02-.03.41-.19h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "63.73 33.91 63.75 33.94 63.49 34.03 64.1 35.7 64.35 35.62 64.36 35.66 63.64 35.92 63.63 35.88 63.87 35.8 63.26 34.11 63.02 34.2 63.01 34.17 63.73 33.91 63.73 33.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m64.89,33.61c.08-.02.17-.02.24.01.09.03.16.08.23.16.07.07.13.16.19.26.04.09.09.2.11.3.02.12.04.21.05.31,0,.08,0,.17-.01.25-.02.07-.05.15-.09.21-.04.06-.1.13-.19.2-.08.07-.18.11-.32.15l-.72.16v-.04s.27-.06.27-.06l-.12-.53-.16-.68-.12-.53-.26.06v-.04s.89-.2.89-.2h0Zm-.4.12l.4,1.74.24-.05c.09-.02.17-.06.24-.13.07-.05.1-.18.1-.36,0-.18-.03-.37-.08-.57-.05-.24-.11-.4-.19-.51-.07-.1-.15-.17-.22-.18-.07-.02-.15-.02-.22,0l-.27.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m66.68,33.48c.08.04.15.11.2.19.07.08.13.18.16.3.03.12.07.25.08.36,0,.11,0,.22,0,.31-.01.1-.04.2-.08.27-.04.08-.08.15-.17.22-.08.07-.17.11-.29.12-.08,0-.14,0-.19,0-.05-.02-.1-.04-.14-.07-.04-.03-.11-.11-.21-.23-.1-.12-.16-.32-.19-.57-.01-.24.03-.45.13-.64.1-.19.26-.3.46-.32.1,0,.17.02.25.06h0Zm-.45.05c-.04.05-.07.1-.09.16-.02.06-.02.16-.03.3-.01.15,0,.3,0,.44.01.12.03.21.04.3.02.08.04.14.05.2.02.05.03.08.05.1,0,.02.02.03.03.05.01.01.03.02.04.03.01.01.04.03.08.06.05.02.1.04.16.03.07,0,.13-.04.17-.08.04-.04.09-.08.11-.12.03-.06.04-.1.03-.15v-.37s-.01-.27-.01-.27c-.02-.25-.05-.43-.1-.53-.05-.1-.09-.17-.14-.2-.06-.03-.12-.05-.18-.04-.08,0-.15.04-.21.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m67.99,33.37c.08.04.14.09.18.17.06-.04.11-.11.16-.18v.2s0,.25,0,.25v.2c-.04-.13-.06-.22-.08-.28-.02-.05-.05-.12-.09-.17-.05-.07-.11-.12-.18-.16-.08-.04-.16-.06-.23-.06-.04,0-.1,0-.18.04-.07.03-.11.07-.14.13-.03.06-.05.11-.05.15s.03.08.08.14c.05.06.14.12.26.18l.34.18c.1.06.19.13.25.21.07.08.09.18.09.3v.07c-.03.17-.09.28-.2.34-.13.05-.22.08-.29.08-.11,0-.19-.02-.26-.07-.06-.04-.12-.09-.13-.11l-.05-.06s-.07.05-.11.11l-.09.12v-.75s.04,0,.04,0c.02.17.06.31.15.43.07.14.15.21.25.25.09.03.16.05.21.04.11.01.2-.03.28-.1.08-.08.12-.17.12-.26,0-.05-.02-.09-.06-.14-.04-.04-.12-.1-.21-.15l-.34-.2c-.13-.07-.23-.15-.3-.22-.07-.08-.1-.18-.1-.29,0-.07.02-.17.07-.28.05-.11.16-.17.35-.19.11,0,.19.03.26.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m71.1,33.78l.18.04.15.02v.04s-.25-.06-.25-.06l-.37,1.75.25.06v.02s-.75-.16-.75-.16v-.02s.28.06.28.06l.36-1.68-.27.53-.38.72c-.07.13-.11.2-.14.25-.03.04-.05.08-.06.1v-.11s-.03-.09-.04-.14l-.05-.64-.04-.6-.02-.31-.32,1.54s0,.05,0,.06c.01.02.03.03.04.04.01.01.03,0,.04.02l.1.04.07.02h-.01s0,.02,0,.02l-.18-.04-.24-.05-.18-.04v-.03c.19.03.29.02.3-.06l.1-.47.13-.59.1-.47s0-.06-.03-.08c-.03-.02-.05-.03-.1-.05l-.14-.04v-.04s.56.12.56.12v.26s.05.49.05.49l.02.47v.23s.02,0,.02,0l.2-.39.28-.49.2-.39.15.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m73.12,34.6l-.26.58h-.01s.07-.27.07-.27c0-.06.01-.12,0-.19-.02-.07-.05-.13-.1-.17-.06-.04-.14-.1-.24-.13l-.09-.04-.12-.05h-.01s-.01-.02-.01-.02l-.33.72.13.06.1.05s.1.01.13-.01c.04-.04.08-.08.11-.13l.1-.14h.01s-.34.78-.34.78h-.01s.04-.15.04-.15c0-.04.02-.05.02-.06s0-.04,0-.06c0-.04,0-.06,0-.1-.02-.03-.03-.06-.07-.08l-.23-.1-.38.85.06.03.09.04.06.03c.17.07.3.09.39.06.09-.03.15-.06.18-.09.02-.03.04-.04.06-.05.01,0,.02-.01.04-.04l.07-.13.08-.13h.01s-.29.66-.29.66l-.39-.17-.49-.22-.38-.18v-.02s.25.1.25.1h.01s.02-.02.02-.02l.72-1.59s-.1-.06-.19-.1l-.05-.02v-.02s1.23.54,1.23.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m74.7,35.54c-.14-.08-.26-.1-.34-.05l-.18.11-.23.13-.18.11-.03.36-.03.46-.03.36.18.09-.02.04-.2-.11-.24-.16-.2-.11.02-.04.25.16.02-.29.03-.36.02-.29-.19.13-.24.14-.19.11s-.04.04-.06.05c-.03.06.01.14.17.24v.02s-.18-.1-.18-.1l-.22-.12-.17-.1h.02c.14.07.29.08.41,0l.19-.11.26-.17.19-.11.02-.31.02-.4.02-.31-.17-.1v-.02s.62.36.62.36l-.02.03-.23-.13v.24s-.02.31-.02.31v.23s.16-.1.16-.1l.2-.13.16-.1s.03-.03.04-.04c.02-.03.02-.06-.02-.09-.03-.02-.08-.06-.14-.11v-.02s.52.31.52.31v.02h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "75.67 36.23 75.65 36.25 75.44 36.09 74.34 37.49 74.54 37.65 74.52 37.69 73.93 37.22 73.94 37.19 74.14 37.34 75.25 35.93 75.04 35.78 75.06 35.75 75.67 36.23 75.67 36.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m76.3,36.78c.08.08.13.22.12.4h.12s.13-.02.13-.02h0s0,.02,0,.02l-.45.47h-.01c.14-.3.21-.5.17-.63-.03-.12-.08-.2-.12-.23-.05-.06-.13-.07-.21-.08-.1,0-.19.04-.29.1-.11.06-.21.15-.32.26-.02.03-.04.05-.08.09-.03.04-.06.08-.11.13l-.14.17c-.04.05-.07.1-.11.15-.03.04-.06.1-.09.18-.03.07-.02.17.03.27.02.03.04.06.07.09.04.03.09.06.14.07.1.01.18,0,.26-.01.08-.03.15-.05.2-.08.05-.03.09-.04.15-.09.05-.03.09-.06.14-.08h.01s-.51.56-.51.56c-.01-.02-.02-.05-.02-.06,0-.02,0-.05.02-.09v-.1s.01-.01.01-.01h-.01c-.18.02-.31,0-.39-.09-.08-.08-.14-.17-.16-.27,0-.11,0-.24.05-.41.04-.17.15-.34.3-.5.13-.14.25-.24.36-.27.09-.02.18-.05.22-.06.05-.02.09-.02.13-.02.03-.02.08,0,.14,0,.06.02.14.04.2.08l.05.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m77.26,38.4l-.44.65-.41.61.14.18h-.02s-.01.02-.01.02l-.14-.18-.18-.22-.14-.18h.01s.01-.01.01-.01l.16.2.11-.14.14-.19.09-.14-.33-.43-.21.07-.2.08-.03.02c-.06.05-.03.15.09.3l-.02.03-.38-.49h.02c.09.1.19.14.3.09l.55-.21.71-.27.36-.14h.02s0,.05,0,.05c.01.01,0,.02,0,.04l-.2.28h0Zm-.5.32l.2-.28.16-.22-.26.1-.32.13-.24.11.31.4.15-.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m78.38,39.36l-.25.41-.31.53-.24.41.99-.58c.11-.07.12-.18.03-.34h.02s.31.5.31.5l-.03.02c-.1-.16-.19-.21-.28-.15l-1.43.85v-.03s.28-.5.28-.5l.37-.62.29-.5-1.2.71c-.08.06-.12.12-.1.19.02.08.04.13.05.14l.03.06-.03.02-.1-.17-.13-.22-.1-.17h.02s.04.04.04.04l.03.06s.06.04.11.04c.06,0,.1,0,.13-.02.04,0,.06-.02.09-.04.06-.02.14-.06.24-.13l.96-.57c.06-.03.04-.14-.06-.29l.03-.02.24.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m79.3,41.5c-.02.09-.06.17-.11.25-.06.09-.14.17-.24.24-.1.07-.22.14-.32.19-.11.03-.21.07-.31.08-.11.02-.19.02-.29.01-.09-.02-.17-.06-.26-.11-.09-.06-.16-.14-.2-.25-.03-.08-.05-.14-.04-.2,0-.05,0-.1.02-.15.02-.04.07-.13.16-.27.1-.13.25-.24.5-.35.22-.08.43-.11.64-.06.22.04.36.16.44.36.03.08.04.16.01.25h0Zm-.18-.42c-.05-.03-.11-.05-.18-.04-.06,0-.17.03-.31.06-.14.03-.27.07-.41.13-.12.05-.21.08-.28.12-.07.03-.13.07-.17.1-.04.04-.08.07-.09.08-.02.01-.03.03-.04.04,0,.01,0,.04-.02.05,0,.01-.02.05-.03.1-.02.04-.01.1.01.15.03.07.06.11.12.14.05.03.1.05.15.06.05.02.1.02.14,0l.35-.1.26-.1c.23-.09.39-.18.48-.25.09-.07.14-.13.16-.2,0-.06,0-.12-.02-.18-.03-.08-.07-.14-.14-.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m79.74,42.78c-.02.07-.05.15-.11.21.07.05.14.08.24.11l-.2.05-.26.07-.19.05c.11-.07.19-.13.24-.15.05-.03.1-.08.14-.13.05-.07.08-.14.1-.23.02-.09.02-.17,0-.24-.01-.03-.04-.09-.1-.15-.04-.07-.11-.1-.17-.1-.07,0-.12-.01-.16,0-.04,0-.08.04-.11.12-.04.06-.07.16-.09.3l-.08.38c-.01.12-.06.22-.12.3-.05.08-.14.13-.27.17l-.06.02c-.18.03-.3,0-.39-.1-.08-.09-.14-.18-.16-.25-.03-.1-.04-.2-.01-.28.03-.07.05-.12.07-.15l.04-.08s-.08-.04-.14-.06l-.14-.05.71-.21v.02c-.15.07-.27.16-.37.27-.1.11-.16.21-.16.3,0,.1,0,.17.02.21.02.11.09.18.18.24.1.05.19.07.28.05.05-.02.09-.06.12-.11.03-.05.06-.13.08-.25l.08-.38c.02-.13.07-.25.12-.34.06-.09.14-.16.25-.19.07-.02.17-.02.29,0,.12.01.21.1.29.27.02.11.03.19.01.28h0Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(55.19 64.98) rotate(-5.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Gobierno del Estado"), /*#__PURE__*/React.createElement("tspan", {
    x: -4.06,
    y: 3.89
  }, "de Michoa"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 10.53,
    y: 3.89
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.14,
    y: 3.89
  }, "\xE1n de O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 22.98,
    y: 3.89
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.58,
    y: 3.89
  }, "ampo"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m150.85,156.68c-3.73,1.53-10.59,2.47-14.44,1.73-7.91,5.58,12.91.99,14.44-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m137.12,90c-.08-2.02-3.67-2.35-2.05-3.57,3.33-2.39-4.09-.85-1.12-2.6,4.52-2.4-2.85-1.42-1.18-2.88-2.49-4.18-6.94-6.51-10.49-.43-3.5.24,1.54,1.77-3,3.28,5.66,4.72-3.07,0,1.3,4.92-3.6,1.96-.86,8.12,3,4.97-4.85-2.03,2.43-3.54,4.33-3.24,6.36-3.21,6.87,8.09,9.2-.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m163.85,101.16c5.92-5.03-2.51-11.09-1.26-7.18-4.74,6.41,1.35,3.84,1.26,7.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m94.47,107.62c-6.71-3.87.38-11.35-.08-7.29,5.83,5.45-.62,4.02.08,7.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.28,73.71c-5.31-2.59-12.11-2.62-12.49-.36-3.03,1.12-13.73.65-5.85,1.91-.56.41-3.13,0-2.89,1.53.74,1.91,5.67-3.37,4.93,1.27.92.27,5.58-3.35,5.49-.32.68.05,5.42-1.35,6.09-3.11-.36,1.82-.58,3.3.83,1.08,2.26.47-1.43-4.3.38-1.3,1.2.67,2.19.78.38-.24-1.36-2.8,2.75,2.64,3.12-.46m-2.16-.03c-.68.06-.77-.83-.08-.89.72-.08.79.82.08.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m105.49,79.58c.48,2.54,1.59,14.4,2.77,5.31-6.11.63,3.88-1.21.59-3.05,5.7-1.8,4.89,10.28,1.22,3.77,4.36,2.51-.75-5.66-1.03.25,6.48,9.02,10.23-7.71-3.55-6.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m103.59,82.28c1.18,3.95.44,2.61-4.46,2.47,3.33-2.18,1.89-.98,4.46-2.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m98.71,85.22c8.72-.85,5.76,5.33,15.47,7.33-4.05,4.1-12.96-7.17-15.47-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m88.02,84.59c.21.96,2.54,4.83-.76,4.73,2.68,1.61,1.42,1.21-2.24.57,1.49-2.84,3.57-1.55,2.99-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m92.66,90.86c-1.43-1.23-6.05,1.11-5.62,2.16,1.24.45,5.26-1.56,5.62-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m88.33,84.04c7.96,5.26,31.6,11.18,18.21,9.75-12.61-2.91-13.79.51-18.21-9.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m128.73,99.21c-14.02-13.44-11.25,5.43-21.56-2.61,6.5,2.88-.14-8.13-2.91,4.38,5.17-2.04,18.48-5.02,24.46-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m147.93,75.63c.16,3.32.76,13.21-1.75,5.73,6.07-.5-4.03-.48-1.13-2.89-5.95-.71-2.92,11.01-.5,3.93-3.84,3.28-.32-5.69,1.06.05-4.73,10.06-11.48-5.69,2.33-6.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m150.29,77.93c-.43,4.1.04,2.66,4.84,1.61-3.68-1.51-2.03-.62-4.84-1.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m155.61,79.92c-8.7.76-4.67,6.3-13.83,10.06,4.72,3.29,11.46-9.46,13.83-10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m166.01,77.33c-.01.99-1.58,5.22,1.63,4.51-2.36,2.06-1.19,1.44,2.29.15-1.96-2.52-3.77-.87-3.92-4.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m162.61,84.34c1.18-1.47,6.15-.03,5.92,1.08-1.14.67-5.45-.57-5.92-1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m165.59,76.84c-6.83,6.64-28.96,16.82-16.09,12.94,7.95-2.93,15.2-3.27,16.09-12.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m150.07,90.75c11.3-2.36,13.78-9.69,14.33,1.54-4.41-2.05-4.03-4.5-3.31.58-8.98-4.02-.3-.65-4.07.95,3.45,3.64-6.24.9-6.95-3.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m164.89,86.83c7,19.53-6.88,13.71-.72,16.89-3.45,1.52-4.48-1.69-7.62,6.66,8.04-5.29,8.46-6.56,10.39,4.73.18-11.68,11.33-24.3-2.05-28.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m163.99,107.51c-8.5,4.99-6.52,7.53-5.88,15.19,2.24-7.74,9.3-8.37,5.88-15.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m156.46,119.8c2.42,20.3,16.69-1.86,5.09,5.25-2.13.68-2.22-2.44.39-3.33,16.27,4.99-9.89,17.76-5.48-1.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m162.91,125.41c-.17-1.57,2.35-1.82,2.48-.23.18,1.62-2.35,1.84-2.48.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m106.1,94.84c-11.54-.22-15.33-6.98-13.82,4.16,3.98-2.83,3.12-5.17,3.38-.04,4.64-2.48,4.76-5.31,2.48.34,2.92-.01,1.1-.96.82,2.26,6.06-3.6,4.66-.66,7.14-6.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m90.8,93.73c-3.27,20.33,9.19,12.26,3.81,16.47,3.69.86,4.12-2.5,8.72,5.13-8.85-3.73-9.52-4.86-9.3,6.56-2.38-11.44-15.6-21.79-3.23-28.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m95.5,113.89c9.27,3.34,7.85,6.19,8.6,13.84-3.65-7.18-10.7-6.51-8.6-13.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m105.18,124.58c1.33,20.4-16.72,1.25-4.04,6.1,5.22-2.6-6.29-5.4-5.53.86,3.75,11.65,13.7,1.69,9.57-6.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m99.87,131.28c-.12-1.6-2.65-1.34-2.48.23.13,1.61,2.66,1.39,2.48-.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m128.73,99.21c11.23-15.8,12.05,3.27,20.67-6.54-5.87,4.02-1.32-8.02,3.67,3.77-5.44-1.04-19.09-1.54-24.34,2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m178.3,178.04c-2.15,1.95-8.71,3.68-8.31,6.19,1.36,1.15,9.94-6.42,8.31-6.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m151.04,194.13c-.68.35-1.08.61-1.08.61-.14-.09,1.79.3,1.08-.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m162.84,190.1c-2.63,1.01-8.61,1.49-9.42,3.73.8,1.7,10.46-3.31,9.42-3.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m148.51,192.35c-1.17.31-2.62,1.49-2.49,1.31-.32-.15,3.24,0,2.49-1.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m148.27,189.45c-.32.26-1.08.96-1.16,1.06.32-.22,1.98-.25,1.16-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m161.83,182.2c-2.95,1.25-11.69,3.36-11.21,6.8,2.57-1.03,11.94-5.9,11.21-6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m149.8,202.36c-2.67-.68-6.31,3.96-1.87,3.72,1.75-1.91-3.87-1.34-.37-2.61,1.71.21,2.32,3.69.26,3.78-5.7-2.76-.16-3.26-5.85-9.55-8.32,1.77,15.02,17.98,7.83,4.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m134.46,195.17c-3.84.49-8.15-3.88-10.28-6.21,2.52,1.96,7.88,4.08,10.28,6.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m144.24,197.16c2.16-1.8,7.14-2.34,9.57-.89-2.46.67-7.05,1.15-9.57.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m133.96,196.08c-9.71-.97-22.28-6.87-30.42-12.58,8.43,5.28,21.83,9.22,30.42,12.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m129.21,193.87c-4.23-.52-10.62-4.78-13.91-7.2,3.5,1.87,11.45,4.33,13.91,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m133.05,197.14c-13.23-1.39-29.91-9.44-39.96-16.92,10.48,7.18,27.77,13.04,39.96,16.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m131.58,198.06c-12.6-1.14-25.84-7.18-36.11-14.12,10.54,6.54,24.6,10.49,36.11,14.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m130.55,198.53c-1.54,1.41-9.02.96-9.74.8.66-.17,8.36-2.25,9.74-.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m126.36,197.88c-1.93,1.16-10.04-.28-10.84-.54.76-.06,9.48-1.13,10.84.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m121.4,196.82c-3.74.59-10.69-1.57-14.01-2.53,3.38.4,11.24.38,14.01,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m144.01,194.62c1.05-.11,1.19,1.52.15,1.6-1.02.11-1.18-1.52-.15-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m142.9,195.53c-.23-.4-1.54.74-1.33.51-.15-.12,1.88.44,1.33-.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m153.46,192.2c-2.47,1.16-8.58.62-8.26,3.66,2.55-.08,8.88-3.41,8.26-3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m152.14,193.14c1.05-.11,1.21,1.51.15,1.59-1.02.11-1.16-1.51-.15-1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m149.65,191.42c1.01-.11,1.18,1.54.15,1.62-1.05.11-1.19-1.54-.15-1.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m157.64,189.74c1.04-.12,1.2,1.52.15,1.6-1.02.11-1.17-1.52-.15-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m156.55,190.73c-.86.48-1.4.83-1.4.83-.24-.1,2.01.05,1.4-.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m168.73,183.55c1.05-.11,1.18,1.51.15,1.6-1.03.11-1.19-1.51-.15-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m172.23,184.17c-3.64,1.82-11.88,2.98-13.32,6.25,2.83.17,13.94-5.43,13.32-6.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m141.81,191.99c1-.12,1.17,1.51.15,1.59-1.08.12-1.21-1.52-.15-1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m140.89,193.45c-.34.46-.51.74-.51.74-.05-.03,1.34-.27.51-.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m148.58,187.57c-1.78,1.15-6.91,2.83-5.51,5.1,1.2-.13,10.71-7.63,5.51-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m149.36,188.31c1.01-.12,1.18,1.5.15,1.59-1.05.11-1.18-1.52-.15-1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m156.41,186.92c1.04-.11,1.19,1.52.15,1.59-1.02.11-1.17-1.51-.15-1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m161.56,186.88c-3.22.5-16.22,6.63-7.63,4.49,1.6-.74,16.23-7.16,7.63-4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m155.35,188.08c-.42.54-.83.67.11.46.29-.02-.09-.27-.11-.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m165.28,183.79c1.03-.11,1.18,1.53.15,1.61-1.05.12-1.2-1.53-.15-1.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m167.6,184.46c-.94.37-1.27,1.07-2.14,1.36-.22-.16,3.35.06,2.14-1.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m163.52,181.43c1.03-.11,1.19,1.51.15,1.6-1.05.11-1.18-1.51-.15-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m162.46,182.61c-.21.19-.73.77-.73.79.41-.12,1.43-.01.73-.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m172.78,176.06c-2.31,1.42-9.07,3.38-8,6.07,1.46.93,9.3-5.38,8-6.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m139.73,193.97c-.78-.27-1.92,3.26-1.15,3.53,3.94.65,2.97-2.12,1.15-3.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m138.59,194.35c-1.12-1.65-2.68,4.89-.77,2.94.02-.28,1.03-2.72.77-2.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m137.19,194.48c-1.15-1.66-2.66,4.87-.8,2.95.02-.28,1.04-2.73.8-2.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m135.77,194.61c-.92-1.36-2.26,3.08-1.44,3.28.88.24,1.46-2.76,1.44-3.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m130.84,198.76c-3.77,1.76-9.65,1.94-6.1,5.75.42-.15,9.88-7.86,6.1-5.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m144.92,197.45c4.05,1.03,9.82.14,7.07,4.53-.44-.05-11.15-5.9-7.07-4.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.66,197.95c-7.57,1.9-1.58,8.9-6.62,11.09-2.04.32-2.05-3.21-.41-3.74.92-.47,1.89,1.21.58,1.04-2.74,1.06,1.64,3.17,1.37-.52-13.65-3.85,1.23,13.99,5.09-7.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m143.07,193.13c1.02-.11,1.18,1.54.15,1.61-1.04.12-1.19-1.53-.15-1.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m142.04,194.39c-.35.32-.57.52-.57.52-.09-.03,1.05-.07.57-.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m155.3,187.83c-3.03,1.24-11.01,2.66-10.95,5.99,3.47-1.51,7.96-3.45,10.95-5.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m164.17,184.77c-.4.34-.72.62-.99.88-2.21,1.37,2.32.19.99-.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m165.55,182.69c-2.37,1.01-9.43,1.95-7.88,5.19,2.39-.69,8.51-4.26,7.88-5.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m179.03,172.88c-2.98,4.09-12.75,7.51-12.48,11.61,3.47-.93,14.19-10.01,12.48-11.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m133.24,91.49c.75,1.22-10.8,2.28-10.31.96-.74-1.23,10.82-2.32,10.31-.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m128.83,100.26l-24.8,2.31,5.61,60.27c1.09,11.74,20.16,2.42,25.99,10.41,4.22-8.93,24.67-3.29,23.58-15.03l-5.61-60.27-24.76,2.31Zm10.48,1.91c.51-3.29.42.96,2.62-.25-1.14.66-1.31,1.52-.58,2.6-1.78-.67-4.73-1.94-2.05-2.35Zm-10.68.99c.37-1.72.33-1.73,1-.09,3.24-.54-.75.72,1.03,2.45-1.7-.63-4.77-1.96-2.03-2.35Zm-10.69,1c.53-3.29.42.95,2.63-.25-1.14.66-1.3,1.52-.57,2.59-1.72-.63-4.79-1.98-2.06-2.35Zm-10.87,1.01c.5-3.29.43.95,2.63-.25-1.14.66-1.32,1.52-.58,2.6-1.7-.63-4.87-2.08-2.05-2.35Zm1.41,15.14c.5-3.31.43.96,2.63-.25-1.13.65-1.33,1.49-.59,2.57-1.75-.69-4.73-1.77-2.04-2.32Zm1.35,14.48c.7-2.65,1.63.45,2.04,2.33-1.7-.69-4.99-1.99-2.04-2.33Zm-.27,14.62c1.81-.54,5.05-1.19,3.02.69.87,2.5-1.45.65-3.02-.69Zm6.6,16.91c-.96-.87-1.82-.77-2.61.24,1.45-2.02-2.77-2.5.56-2.57.55-3.3.41.96,2.63-.25-1.12.66-1.32,1.51-.58,2.57Zm9.95,1.38c-1.8-.63-4.74-1.94-2.04-2.33.7-2.62,1.62.47,2.04,2.33Zm10.52,1.92c-1.76-.66-4.73-1.91-2.03-2.32.74-2.53,1.62.39,2.03,2.32Zm10.06-3.84c-1.72-.6-4.77-1.97-2.03-2.33.5-3.28.4.96,2.61-.24-1.13.65-1.31,1.5-.58,2.57Zm-1.68-5.36c-39.35,17.13-30.13-28.63-34.17-51.66,0,0,37.22-3.46,37.22-3.46-2.91,5.71,13.99,59.07-3.05,55.12m11.22,2.16c-1.74-.61-4.75-1.95-2.04-2.33.51-3.31.4.96,2.62-.24-1.12.66-1.31,1.51-.58,2.57Zm.19-15.02c-1.75-.64-4.74-1.95-2.05-2.34.52-3.29.43.96,2.63-.25-1.13.65-1.31,1.51-.59,2.59Zm-1.99-15.98c.9,2.54-1.59.57-3.02-.68,1.3.14,1.94-.45,1.98-1.74,0,2.52,3.71.38,1.05,2.42Zm-1.35-14.48c.92,2.58-1.64.54-3.02-.68,1.3.14,1.94-.45,1.98-1.74,0,2.52,3.71.38,1.05,2.42Zm-1.41-15.14c.86,2.52-1.5.63-3.03-.69,1.29.14,1.94-.44,1.98-1.73,0,2.52,3.71.37,1.05,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m103.81,163.79c4.24,2.71,5.53-14.3.44-10.63.87,3.35.17,7.03-.44,10.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m105.45,166c-1.41-2.63-3.55-1.51-1.6-6.93-13.02,5.52-8.82,19.64,1.6,6.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m101.12,180.31c-1.05-4.02-1.36-14.75-6.3-4.13-.4,5.29,16.72,8.31,6.3,4.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m102.27,179.04c-2.32,1.18,2.42,1.54,2.67,2.1.49-1.42-1.89-2.12-2.67-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m123.63,181.25c-1.73-1.18-.82,1.31-.72,1.3.41.24,2.12-.56.72-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m162.86,159.22c4.32-2.01-1.27-7.27-.11-11.5-6.29-1.67-.6,8.03.11,11.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m163.95,160.55c12.54,10.59,14.08-4.12.26-7.11,2.95,4.97.57,4.27-.26,7.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m173.68,165.66c-7.75-3.89,1.64,9.6-6.4,10.62,3.81.96,13.59-7.67,6.4-10.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m169.79,173.91c1.56-2.48-3.79-.27-2.6,1.43.29-.67,1.83-.82,2.6-1.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m148.86,178.9c-1.24.99.62,1.45.98,1.14.09-.03.51-2.62-.98-1.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m146.37,83.11c-.76,3.35-4.27,5.01-7.47,6.05-2.5-.3,3.42-3.74-1.49-2.33-.68,7.36,12.62-1.01,8.96-3.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m117.64,91.74c2.96-5.05-3.98-3.38-.7-1.7,2.28,3.82-6.73-2.38-3.8.85-7.88-8.36-7.78,1.49,4.51.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m107.83,173.72c-.34-1.35-1.23,1.22-.32.92.36-.12.25-.6.32-.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m111.1,173.73c-.61.06-1.07,2.86-.56,3.13.58-.29,1.04-2.65.56-3.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m117.18,175.31c-.69.18-1.02,2.78-.48,3.3.65-.22.86-2.72.48-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m121.96,181.51c3.35-8.72-25.62-16.86-20.53-2.88-1.03-3.08,22.33,4.6,20.53,2.88m-18-4.89c-.02-1.03-1.62-3.55-.41-1.97,1.84-3.83,1.56.97.41,1.97m2.15.09c-2.68.87-.75-5.78.44-3.37-1.7.14-.97,2.65-.44,3.37m1.39.13c-.54-3.4.02-.43-1.15-.12.23-6.4,3.04-2.68,1.15.12m1.98.27c-2.84.69-.31-6.35.61-3.54-1.74-.1-1.15,2.74-.61,3.54m1,.2c-1.35.29-.52-4.89.77-4.06,1.1.3.42,4.23-.77,4.06m2.4.57c-2.92.44-.23-6.63.64-3.65-1.76-.3-1.23,2.73-.64,3.65m2.21.62c.59-3.77-1.06-2.84-1.99-.57.01-5.59,4.44-2.72,1.99.57m1.56.58c-1.33-.37-.75-4.58.63-4.27,1.04.45.71,4.62-.63,4.27m3.07-2.43c-1.97-1.93,1.23,5.74-1.92,1.96.15-1.84,1.04,2.43,1.23-.06-1.66-1.27-.45-5.1.69-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m169.15,166.11c2.53-2.94-21.6,5.41-18.63,5.66.49,10.56-.2,6.98,10.19,2.61,12.44-3.74,9.76-1.98,8.44-8.27m-16.22,10.46c-1.95-.21-.02-.41.08-.87-2.11-5.44,1.39-1.51-.08.87m1.51-.78c-2.33-1.7-1.71-5.44-.13-.44-1.34-5.02.97-2.88.13.44m1.41-.72c-2.56-1.39.77.08-.12-1.32-3.63-3.13.79-3.34.12,1.32m1.08-.61c-.01-1.95-2.61-3.58-.56-4.13-.49,1.04,1.3,3.21.56,4.13m.89-.4c-.11-1.24-1.65-3.14-.99-3.95.21,1.23,1.7,3.13.99,3.95m1.17-.43c-2.85-1.29-.49-4.83-.91-3.29-1.8,1.52,2.7,2.5.91,3.29m.74-.39c-.17-1.23-1.7-3.14-1.06-3.96.19,1.18,1.75,3.19,1.06,3.96m1.48-.56c-1.15-.73-1.42-.05-2-3.62.84-.39,2.5,3.18,2,3.62m1.61-.47c-2.48-1.57.56.1-.23-1.29-1.41-.35-2.38-4.06-.39-2.07.31,1.31-.33-.11-.7-.15-.79.99,2.98,2.36,1.31,3.5m1.33-.37c-1.04.05-2.36-3.41-1.46-3.96.98.04,2.28,3.39,1.46,3.96m1.35-.32c-1.52.28-2.62-5.95-.59-3.25-2.89.48,2.03,2.58.59,3.25m.77-.21c-.21-1.07-1.84-3.32-1.03-3.82.06,1.15,1.72,3.28,1.03,3.82m1.55-.25c-1.21-.86-1.59-.16-2.02-3.66.86-.16,2.49,3.4,2.02,3.66m.47-.07c-.24-1.02-1.8-3.26-1-3.69-.21,1.91,3.16,3.97,1,3.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m166.72,169.92c.96,0-.44-1.46-.52-2.15.15.72.32,1.44.52,2.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m160.18,171.6c.93-.23-.43-1.54-.58-2.24.2.75.39,1.48.58,2.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m163.2,168.62c-1.1-.82.2,1.83.41,2.52,1.1.76-.25-1.83-.41-2.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m123.76,115.69c2.75.45.8-3.93,2.35-5.25-2.33,1.08-5.86,5.7-2.35,5.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m126.57,111.08c1.03-.44,1.04-.63.95-1.7-.43-.07-2.56,2.41-.95,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m127.88,111.4c-1.18-1.31-3.96,2.32-1.51,2,2.42,1.29,2.32-5.49,1.51-2m-1.65.46c-.28.1-.35-.21-.1-.29.25-.08.35.2.1.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m125.47,114.43c-.26,2.66,2.36,1.05,2.01-.73-1.22-.25-1.64.08-2.01.73m1.05.4c-.09.42-.61.32-.53-.1.07-.41.61-.3.53.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m124.87,126.23v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m124.87,126.22s0-.02,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m131.66,135.13c1.3-5.58-4.43-5.64-8.27-6.42-.95-1.28,7.75,1.46,7.78,1.18-.45-4.24-5.07-2.1-5.46-6.1,1.28-8.77,5.41,4.19,3.29-3.92-3.89-2.43-4.51-5.26-9.86-4.72.65-1.34,1.1-.61,1.41-1.27-.74-.63,1.1.31-.02-.37-.12-.54.69.38.3-.16-2.15-1.56-2.98,5.36-7.5,4.98,1.88,3.38,8.18-5.05,2.69,4.88.46,4.3,2.03,8.88-1.1,12.15.1.31,8.89-9.63,8.25-7.36-15,9.16,1.28,14.27.02.79-.61,6.99,2.28,7.65,8.47,6.34Zm-11.71-21.85c.74.24.02,0-.13.25-.24.13-.13-.21.13-.25m-.9,17.42c.16-.58-.18-1.6-.22-2.12,1.49,1.27,1.41.96.22,2.12Zm2.35-8.79c1.58,1.77,5.56,4.34,1.96,4.97.83-1.44-.53-3.5-1.96-4.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m133.16,177.84c-.66-.45.16,3.17.02,3.25.94,0,.37-2.75-.02-3.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m131.6,180.02c.99.16-.04-1.56.02-2.34-.03.78-.02,1.56-.02,2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m125.93,176.62c-.47-.31-.36,1.51.21,1.34.29-.21.21-1.23-.21-1.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m129.2,177.76c-.49-1.34-.75.69-.25.93.52.09.23-.62.25-.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m126,178.38c-.9.12.72,2.71.39.46-.03-.25-.16-.37-.39-.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m141.62,176.95c-.63-1.12-.41.89-.37,1.15.62-.05.42-.72.37-1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m139.87,179.48c.16-.05.3-.09.47-.13-.47-2.72-.47-2.44-.47.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m146.38,174.48c-.38.49-.25,3.27.45,3.12.17-.74.21-2.82-.45-3.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m144.56,172.28c-7.78,9.7-26.59-7.19-22.43,8.49,20.73,9.77,37.8-11.74,22.43-8.49m-19.94,7.36c-1.86.26-2.02-4.24-1.14-4.25-.03,1.79,0,3.25,1.14,4.25Zm.56.21c-1.05-.69-.4-2.87-.68-4.12,1,.69.3,2.87.68,4.12m1.52-2.06c-.36.66.18.98.14,1.79-2.29,3.12-1.89-7.83-.14-1.79m1.39-.62c-1.23-.59-.84,3.1.28,3.15-1.47,2.46-2.42-6.45-.28-3.15m1.54,3.91c-.55-1.31-2.5-1.07-.72-4.21.95.5,1.02,4.14.72,4.21m.81.17c.38-1.76-1.83-4.9.46-4.05-.86.62.47,3.65-.46,4.05m1.92.24c-.97-1.16-1.5-.66-1.07-4.26.97,0,1.73,4.14,1.07,4.26m1.16.09c-1.59.19-1.19-6.8.3-3.35-.12.57.8,3.42-.3,3.35m1.47-1.77c-.36.47-.86-.33-.56-.68.35-.47.82.33.56.68m1.83,1.67c-1.65,1.28-1.63-4.31-1.13-4.18.25,1.06-.1,4.19,1.13,4.18Zm.88-3.92c-1.65.55.19,1.92-.44,3.36,1.53,2.26-2.84-5,.44-3.36Zm1.46.54c-1.35-2.26-1.07,2.19-.31,2.61.67-.75-.78-1.82.06-1.97,1.64,1.38-1.11,4.28-.92.43-.7-1.5.94-3.73,1.17-1.06Zm1.45,2.61c-.38-2.05-.56.05-1.11.29-.66-5.5,1.79-4.43,1.11-.29m1.42-.46c-.39-1.08-2.29.11-.69-4.07,1.05.1.89,3.63.69,4.07m1.65-.66c-2.92,1.41-.53-7.87-.97-2,1.48-.46-1.04,1.96.97,2Zm1.81-.85c-.27-3.1-1.11-.19-1.63.77-1.05-3,3.15-6.21,1.63-.77m1.3-.6c-1.16.39-1.4-3.68-.45-4.11,1.2-.39,1.46,3.64.45,4.11m1.56-.9c-2.47-.97.73-.18.16-1.41-2.27-.46-.53-4.5.2-1.77-2.57-.84,1.65,1.7-.37,3.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m111.69,109.54c3.34,29.78-3.35,70.54,40.29,46.27-6.41-36.46,10.08-57.25-40.29-46.27Zm37.39,23.97c-22.53,6.96-16.7-9.83-19.09-24.85,22.53-6.96,16.7,9.84,19.09,24.85Zm-17.42,1.62c-22.52,6.96-16.68-9.85-19.08-24.85,22.52-6.96,16.68,9.85,19.08,24.85Zm-14.53,23.92c-1.7-15.51-5.82-24.74,14.61-23.14,1.14,15.27,7.79,32.41-14.61,23.14m27.2-.22c-15.55,10.4-8.81-15.7-11.8-23.01,0,0,16.62-1.54,16.62-1.54-1.45,5.54,8.09,26.21-4.83,24.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m128.68,145.3c-1.69-.18-2.71.23-2.18,2.14,1.71-.09,2.96-.03,2.18-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m127.73,139.96c-2.4-1.11-.7,4.33-1,5.15,2.92.96.72-4.02,1-5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m119.11,140.77c-2.42-1.11-.7,4.32-1,5.15,2.96.96.72-4,1-5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m121.87,144.98c2.05.62,1.79-5.47-.27-4.49-.1-.03.22,4.65.27,4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m122.04,147.88c.25-.58-1.38-.42-1.05.1,0,0,1.05-.1,1.05-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m122.11,146.43c.46-.56-1.14-.31-1.02.09,0,0,1.02-.09,1.02-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m122.73,145.23c.53-.27-1.04.04-.95.09,0,0,.95-.09.95-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m121.31,149.03c0,.48.93.16,1.18.19,0-.48-.93-.16-1.18-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m122.2,150.1c.08.14.99-.02,1.11-.01-.06-.14-1,.02-1.11.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m124.49,148.55c-1.07.49-1.57-1.71-.63-2.08,1.07-.49,1.58,1.71.63,2.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m126.02,148.91c.49-3.29-1.88-5.21-3.66-2.83-.62,3.39,2.08,5.14,3.66,2.83Zm-1.36.15c-1.81.77-2.41-3.04-.64-3.19,1.49-.13,1.9,2.68.64,3.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m124.92,149.87c-.56.19.17.17.31.13-.08-.09-.2-.28-.31-.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m124.61,145.1c.34-.42-.15-.15-.35-.19,0,.19.21.13.35.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m122.89,149.24c-.15.15-.8.18-1.01.2-.03.11,1.67.17,1.01-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m121.98,149.95c.16-.09,1.36.08,1.17-.36-.17.08-1.32-.07-1.17.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m122.44,148.34c.03-.55-.96-.19-1.26-.22-.07.58,1.28.54,1.26.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m121.25,148.88c.11-.04,1.21-.01,1.19-.25-.11.04-1.22,0-1.19.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m122.14,146.57l-1.1.1c-.09.16,1.57.14,1.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m121.17,147.4c-.29.12.91-.08.88-.05,1.08-.57-1.2-.79-.88.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m123.02,150.28c.09.22,2-.04.75-.36-.06.35-.47.35-.75.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m122.71,145.38l-1.13.11c-.11.38,1.52.3,1.13-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m121.56,146c.34-.15,1.06.16,1.19-.2-.08.03-1.2.05-1.19.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m123.07,144.94c.29.37.66.18.57-.14-.51,0-1.86.25-.57.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m121.91,150.15c-.13-1.43-.24-.04-.16.35.1-.13.55-.22.16-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m123.4,150.32c.11-1.1-.52-.03-.91.08,0,0,.91-.08.91-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m126.32,152.09c.3,1.14,1.69,3.01.55,3.84,4.16,1.35,3.25-9.05-.55-3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m130.56,147.4c-5.12-1.62-7.92,7.9-1.61,2.36,1.72,10.22,2.93,3.91,1.61-2.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m119.95,155.98c.4-1.01-2.34-.75-1.77.16,0,0,1.77-.16,1.77-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m120.08,153.5c.75-.95-1.95-.53-1.76.16,0,0,1.76-.16,1.76-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m121.12,151.47c.87-.49-1.75.03-1.6.15,0,0,1.6-.15,1.6-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m118.7,157.94c.02.83,1.6.29,2.04.34-.01-.84-1.6-.29-2.04-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m120.23,159.72c.12.3,1.68,0,1.9.01-.13-.29-1.67,0-1.9-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m124.13,157.12c-1.82.79-2.66-2.91-1.09-3.54,1.83-.83,2.67,2.92,1.09,3.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m126.72,157.74c.89-4.71-2.79-9.22-6.23-4.8-.93,5.63,3.23,8.79,6.23,4.8Zm-2.31.25c-3.07,1.29-4.1-5.14-1.09-5.43,2.53-.21,3.2,4.56,1.09,5.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m124.83,159.33c-.84.44.29.28.53.25-.13-.15-.32-.45-.53-.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m124.31,151.27c.57-.72-.21-.29-.58-.35.01.31.37.25.58.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m121.4,158.29c-.27.26-1.39.28-1.74.33-.01.2,2.79.25,1.74-.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m119.88,159.5c.29-.14,2.25.13,1.96-.62-.29.15-2.27-.13-1.96.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m120.64,156.77c.05-.96-1.65-.35-2.17-.4-.03.95,2.05.94,2.17.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m118.59,157.68c.2-.07,2.06-.03,2.04-.42-.2.07-2.06.03-2.04.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m120.13,153.77l-1.87.17c-.13.27,2.69.24,1.87-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m118.47,155.17c-.24.18,1.83-.11,1.92-.25.59-1.14-2.35-.76-1.92.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m121.61,160.06c.12.37,3.39-.03,1.27-.62-.11.58-.8.61-1.27.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m121.08,151.73l-1.89.18c-.24.66,2.63.51,1.89-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m119.15,152.82c.42-.2,1.7.12,1.88-.18.57-.45-2.08.02-1.88.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m121.7,150.97c.48.62,1.12.4.97-.24-.75-.01-3.25.42-.97.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m123.75,150.53c-.04.3.62.08.75.1.12-.33-.66-.1-.75-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m119.77,149.65c1.29,4.67.77-3.39.14-3.58-3.17-1.35-2.83,7.65-.14,3.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m144.96,141.26c6.6-5.39,3.35,10.57,5.45,15.98,2.38-.92-1.24-27.91-5.45-15.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m148.52,145.69c-1.04-6.2-8.79-3.23-13.01-3.18-6.16,8.78,9.63,2.05,13.01,3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m149,156.19c.56-24.77-27.44,2.72-6.56,2.41,9.27.17,7.6-2.32,6.76-10.28-2.6-5.89.29,7.77-.19,7.87Zm-3.95-4.11c4.48,1.88,3.89,5.76-1.76,4.85.2-1.53-1.83-6.45,1.76-4.85m.39-3.54c1.68-.44,1.6,3.09,1.54,3.34-2.22.42-4.12-2.2-1.54-3.34m-7.43,1.99c.75-3.97,4.88,1.59,1.29,1.85-1.68.79-.98-.6-1.29-1.85Zm4.92,7.3c-.19.39-5.27.77-5.72.81,1.22-.25,4.76-2.11,5.72-.81Zm-.08-.85c-5.1.77-5.64,1.14-4.18-4.02,4.19-2.16,3.97.69,4.18,4.02Zm-.29-5.25c-1.8.42-1.98-2.54-.27-2.89,1.79.01,2.14,2.98.27,2.89m1.44,6.28c-2.1-1.62,4.08-.41,5.04-.66.61.4-5.1.53-5.04.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m149.34,136.54c-1.5.3-5.52-.28-5.3,2.27,1.38-.7,8.33.76,5.3-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m134.66,158.71c2.11,1.24-.51-10.46-.08-10.76-1.33,1.06.07,9.32.08,10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m141.51,115.57c3.76-.32,3.62-1.6-.11-1.23-3.75.33-3.65,1.61.11,1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m140.69,113.48c.09.93,1.35.8,1.26-.12-.08-.94-1.35-.83-1.26.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m142.24,112.94c-.22,1.52,1.96.77,2.54,1.37.85-1.01-.83-1.33-2.54-1.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m140.29,113.51c-.27-1.07-3,.85-2.55.99-.13.68,2.97-.27,2.55-.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m144.5,112.73c.49-.29,1.18-2.38,1.01-2.51-.11-.09-2.29,2.57-1.01,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m143.55,112.53c.38-.37.53-2.64.31-2.73-.13-.03-1.49,2.94-.31,2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m142.47,112.46c.36-.43.07-2.97-.2-3.05-.14.04-.81,3.29.2,3.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m141.23,112.51c.64-.11-.11-3.7-.35-3.7-.23.06-.3,3.69.35,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m140.01,112.69c1.05.04-.21-3.03-.38-3.03-.24.12-.04,2.67.38,3.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m138.96,112.96c1.18-.03-.66-2.68-.8-2.62-.2.14.35,2.32.8,2.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m138.09,113.33c1.37-.54-3.21-4.19-.81-.85.28.38.6.67.81.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m137.35,124.15c3.76-.33,3.65-1.6-.11-1.22-3.75.32-3.63,1.6.11,1.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m136.51,122.05c.08.93,1.36.81,1.27-.12-.08-.93-1.36-.8-1.27.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m138.07,121.53c-.22,1.53,1.94.77,2.53,1.37.86-1.03-.8-1.33-2.53-1.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m136.13,122.09c-.34-1.03-2.99.85-2.56,1.01-.11.68,3-.25,2.56-1.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m140.33,121.32c.5-.29,1.18-2.38,1.01-2.51-.12-.08-2.27,2.51-1.01,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m139.36,121.12c.4-.36.54-2.65.34-2.74-.17-.01-1.48,2.91-.34,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m138.3,121.04c.36-.4.06-2.97-.19-3.02-.18.02-.82,3.29.19,3.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m137.06,121.08c.65-.11-.11-3.7-.34-3.69-.22.03-.32,3.72.34,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m135.84,121.27c1.05.08-.19-3.02-.38-3-.24.1-.06,2.67.38,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m134.8,121.55c1.16-.01-.67-2.67-.83-2.63-.2.14.35,2.34.83,2.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m133.93,121.9c1.34-.54-3.19-4.16-.83-.84.3.36.58.67.83.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m143.08,131.93c3.76-.33,3.64-1.59-.11-1.23-3.75.33-3.63,1.6.11,1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m142.25,129.82c.07.93,1.36.81,1.25-.12-.07-.93-1.35-.81-1.25.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m143.8,129.3c-.2,1.51,1.94.77,2.52,1.38.87-1.02-.8-1.34-2.52-1.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m141.86,129.86c-.3-1.03-2.99.86-2.54,1-.13.69,2.97-.26,2.54-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m146.05,129.09c.5-.27,1.18-2.39,1.01-2.51-.1-.1-2.26,2.51-1.01,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m145.11,128.89c.4-.38.53-2.66.3-2.74-.15-.01-1.46,2.94-.3,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m144.01,128.82c.38-.42.09-2.96-.17-3.03-.18.03-.81,3.25.17,3.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m142.79,128.86c.64-.14-.11-3.7-.35-3.71-.23.05-.31,3.71.35,3.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m141.58,129.04c1.05.05-.22-3.01-.4-3.01-.23.12-.04,2.67.4,3.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m140.54,129.32c1.12-.05-.67-2.68-.82-2.64-.19.13.33,2.34.82,2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m139.64,129.69c1.28-.23-1.38-2.37-1.47-2.28-.13.18.95,2.04,1.47,2.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m127.24,157.1c-.55.99.4.45.92.52.7.53-.34,3.92,1.47,3.27-1.33-5.25,3.19-4.23,2.46.39,4.71-2.03-3.55-8.62-4.85-4.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m131.76,161.19l-.33-3.55c-2.75-.64-2.08,4.05.33,3.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m125.87,159.51c.42,2.82,3.36.88,2.15-1.54-1.71-.13-1.61.4-2.15,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m125.65,160.69c.03-.83-.16-1.02-.99-.83-.2.83.27.9.99.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m117.13,159.07c-.32,1.12,4.9,2.36,7.2,1.26-2.75.67-6.21-.61-5.83-3.35-1.52-1.8-.06-4.11,1-5.84-1.54-2.88-3.84,6.02-2.38,7.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m127.82,136.32c-2-.09-1.55.27-.87,1.64-1.11,3.88,2.39.11.87-1.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m122.94,136.77c-2.53-.14-.96.48-.92,1.89-.9,3.61,2.43-.4.92-1.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m119.21,137.12c-.25.02-2.34-.16-1.47.63.54,4.18,2.18,2.72,1.47-.63"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 75.63,
    y: 117.29,
    width: 74.59,
    height: 1.9,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-10.48 10.98) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 75.95,
    y: 120.75,
    width: 74.59,
    height: 1.9,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-10.8 11.03) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 76.27,
    y: 124.16,
    width: 74.59,
    height: 1.9,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-11.11 11.07) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 76.59,
    y: 127.62,
    width: 74.59,
    height: 1.9,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-11.43 11.12) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 76.91,
    y: 139.08,
    width: 74.59,
    height: 1.9,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-12.49 11.19) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 159.73,
    y: 111.62,
    width: 24.34,
    height: 1.9,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-9.7 16.43) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 160.06,
    y: 115.08,
    width: 24.34,
    height: 1.9,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-10.02 16.47) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 160.37,
    y: 118.49,
    width: 24.34,
    height: 1.9,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-10.33 16.52) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 160.7,
    y: 121.95,
    width: 24.34,
    height: 1.9,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-10.65 16.56) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 161.02,
    y: 133.41,
    width: 24.34,
    height: 1.9,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-11.71 16.64) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 100.49,
    y: 180.22,
    width: 72.96,
    height: 3.42,
    rx: 0.87,
    ry: 0.87,
    transform: "translate(-16.28 13.49) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 81.7,
    y: 196.1,
    width: 72.88,
    height: 1.9,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-17.76 11.81) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 82.02,
    y: 199.56,
    width: 72.88,
    height: 1.9,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-18.08 11.85) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 82.35,
    y: 203.02,
    width: 72.88,
    height: 1.9,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-18.4 11.9) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 82.67,
    y: 206.47,
    width: 72.88,
    height: 1.9,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-18.72 11.94) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 82.99,
    y: 209.89,
    width: 72.88,
    height: 1.9,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-19.04 11.98) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 83.31,
    y: 213.35,
    width: 72.88,
    height: 1.9,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-19.36 12.03) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 157.06,
    y: 34.23,
    width: 42.74,
    height: 6.45,
    rx: 1.64,
    ry: 1.64,
    transform: "translate(-2.7 16.71) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 157.92,
    y: 43.44,
    width: 42.74,
    height: 6.45,
    rx: 1.64,
    ry: 1.64,
    transform: "translate(-3.56 16.83) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 52.18,
    y: 22.92,
    width: 161.78,
    height: 212.81,
    rx: 16.6,
    ry: 16.6,
    transform: "translate(-11.42 12.9) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(98.33 86.65) rotate(-5.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CERTIFI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 30.46,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.27,
    y: 0
  }, "ADO "), /*#__PURE__*/React.createElement("tspan", {
    x: -2.38,
    y: 10.66
  }, "FIS"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 9.71,
    y: 10.66
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 15.53,
    y: 10.66
  }, "AL DI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 36.32,
    y: 10.66
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 42.83,
    y: 10.66
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 45.39,
    y: 10.66
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 49.44,
    y: 10.66
  }, "AL")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m177.86,190.57c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m179.55,190.41l-.1-1.09c-.02-.16-.16-.28-.32-.27l-.8.07c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m184.81,189.92c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m186.5,189.77l-.1-1.09c-.02-.16-.16-.28-.32-.27l-.8.07c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 187.82,
    y: 188.18,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-16.7 18.3) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m178.16,190.54l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 178.22,
    y: 190.48,
    width: 1.4,
    height: 1.4,
    transform: "translate(-16.96 17.42) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m180.77,191.7c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m179.97,191.78c-.16.02-.31-.11-.32-.27l.03.3.3-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m181.23,190.26c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13-.13-1.39-1.09.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 182.39,
    y: 190.09,
    width: 1.4,
    height: 1.4,
    transform: "translate(-16.9 17.8) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 183.78,
    y: 189.96,
    width: 1.4,
    height: 1.4,
    transform: "translate(-16.89 17.93) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m186.6,190.86c.02.16-.11.31-.27.32l-1.09.1-.13-1.39,1.39-.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m178.32,192.23l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m178.12,193.35c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 178.35,
    y: 191.87,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.09 17.43) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 179.74,
    y: 191.74,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.07 17.56) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 181.13,
    y: 191.61,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.05 17.69) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m182.75,191.52l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m178.42,193.32l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m179.91,194.29c.02.16-.11.31-.27.32l-1.09.1-.13-1.39,1.39-.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m180.1,193.17l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m181.23,193.36l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m181.3,194.16c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 184.04,
    y: 192.74,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-17.14 17.97) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m187.05,192.52c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13-.13-1.39-1.09.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m189.24,192.32c.16-.02.31.11.32.27l.1,1.09-1.39.13-.13-1.39,1.09-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m181.46,195.84l-.1-1.09c-.02-.16-.16-.28-.32-.27l-.8.07c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 182.78,
    y: 194.26,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-17.29 17.86) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m186.72,195.35c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 186.95,
    y: 193.87,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.24 18.24) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m189.77,194.77c.02.16-.11.31-.27.32l-1.09.1-.13-1.39,1.39-.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m178.81,197.49l-.1-1.09c-.02-.16-.16-.28-.32-.27l-.8.07c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 180.13,
    y: 195.91,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.45 17.62) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m185.63,195.46l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 185.69,
    y: 195.39,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.38 18.13) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m188.51,196.29c.02.16-.11.31-.27.32l-1.09.1-.13-1.39,1.39-.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m188.7,195.17l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m177.52,198.72c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m180.3,198.46c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m184.5,198.37l-.1-1.09c-.02-.16-.16-.28-.32-.27l-.8.07c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m185.78,197.14l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m185.86,197.94c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m187.44,196.69l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m190.06,197.85l-.1-1.09c-.02-.16-.16-.28-.32-.27l-.8.07c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 183.17,
    y: 198.43,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.67 17.91) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m188.77,199.07c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m167.95,201.31l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 168.01,
    y: 201.24,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18 16.52) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 169.4,
    y: 201.11,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.98 16.64) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 170.79,
    y: 200.98,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.96 16.77) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m172.25,202.31l1.09-.1c.16-.02.28-.16.27-.32l-.07-.8c-.02-.16-.16-.28-.32-.27l-1.09.1.13,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m176.29,200.53l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 176.35,
    y: 200.46,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.89 17.29) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 177.74,
    y: 200.33,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.87 17.41) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 179.13,
    y: 200.21,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.86 17.54) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m180.58,201.53l1.09-.1c.16-.02.28-.16.27-.32l-.07-.8c-.02-.16-.16-.28-.32-.27l-1.09.1.13,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m183.34,200.98c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m187.4,199.5l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m188.5,199.39c.16-.02.31.11.32.27l.1,1.09-1.39.13-.13-1.39,1.09-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m190.02,200.65c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m189.22,200.73c-.16.02-.31-.11-.32-.27l.03.3.3-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m191.7,200.5l-.1-1.09c-.02-.16-.16-.28-.32-.27l-.8.07c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m194.48,200.24l-.1-1.09c-.02-.16-.16-.28-.32-.27l-.8.07c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m194.78,200.21c-.16.02-.31-.11-.32-.27l.03.3.3-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 195.81,
    y: 198.65,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-17.64 19.08) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 198.59,
    y: 198.39,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-17.6 19.34) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m169.49,202.86l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m169.3,203.99c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 169.53,
    y: 202.5,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.11 16.66) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m171.15,202.41l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m175.15,203.44l-.1-1.09c-.02-.16-.16-.28-.32-.27l-.8.07c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m175.45,203.41c-.16.02-.31-.11-.32-.27l.03.3.3-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m177.83,202.09l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m177.91,202.89c.02.16.16.28.32.27l1.09-.1-.13-1.39-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 179.26,
    y: 201.6,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.99 17.56) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m180.88,201.51l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m187.56,201.18l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m187.37,202.3c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 187.6,
    y: 200.82,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.88 18.33) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 188.99,
    y: 200.69,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.86 18.46) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 190.38,
    y: 200.56,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.84 18.59) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m192.13,201.86c-.16.02-.31-.11-.32-.27l.03.3.3-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m193.2,201.46c.02.16.16.28.32.27l1.09-.1-.13-1.39-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m195.58,200.14c.16-.02.31.11.32.27l.1,1.09-1.39.13-.13-1.39,1.09-.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 200.11,
    y: 199.65,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-17.72 19.49) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m168.5,204.06c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13-.13-1.39-1.09.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 169.66,
    y: 203.89,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.24 16.68) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m173.87,204.67c.02.16.16.28.32.27l1.09-.1-.13-1.39-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m175.28,204.83l1.09-.1c.16-.02.28-.16.27-.32l-.07-.8c-.02-.16-.16-.28-.32-.27l-1.09.1.13,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m179.35,203.35l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m179.16,204.47c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 179.39,
    y: 202.98,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.11 17.58) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m181.94,204.21c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m181.14,204.29c-.16.02-.31-.11-.32-.27l.03.3.3-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m182.4,202.77c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13-.13-1.39-1.09.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m183.62,204.05l1.09-.1c.16-.02.28-.16.27-.32l-.07-.8c-.02-.16-.16-.28-.32-.27l-1.09.1.13,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m186.57,202.38c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13-.13-1.39-1.09.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m189.16,203.24c.02.16-.11.31-.27.32l-1.09.1-.13-1.39,1.39-.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m189.35,202.12l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m190.47,202.31l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m190.28,203.43c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 190.51,
    y: 201.95,
    width: 1.4,
    height: 1.4,
    transform: "translate(-17.97 18.61) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m191.96,203.28l1.09-.1c.16-.02.28-.16.27-.32l-.07-.8c-.02-.16-.16-.28-.32-.27l-1.09.1.13,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m194.64,201.92l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m194.72,202.72c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 197.45,
    y: 201.3,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-17.88 19.25) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 168.4,
    y: 205.41,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.39 16.57) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m171.22,206.31c.02.16-.11.31-.27.32l-1.09.1-.13-1.39,1.39-.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m178.06,204.57l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 178.13,
    y: 204.5,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.26 17.47) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 179.52,
    y: 204.37,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.24 17.6) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 180.91,
    y: 204.25,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.22 17.73) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 182.3,
    y: 204.12,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.21 17.85) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m183.92,204.03l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m186.51,204.89c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m188.09,203.64l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m190.57,203.41l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m192.06,204.37c.02.16-.11.31-.27.32l-1.09.1-.13-1.39,1.39-.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m192.26,203.25l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m168.3,208.29c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 168.53,
    y: 206.8,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.51 16.59) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m170.15,206.71l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 171.31,
    y: 206.54,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-18.48 16.84) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m175.41,206.22l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m175.54,207.61l1.09-.1c.16-.02.28-.16.27-.32l-.07-.8c-.02-.16-.16-.28-.32-.27l-1.09.1.13,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m178.22,206.26l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m178.3,207.06c.02.16.16.28.32.27l1.09-.1-.13-1.39-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m181.08,206.8c.02.16-.11.31-.27.32l-1.09.1-.13-1.39,1.39-.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m181.27,205.68l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m182.39,205.87l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m182.46,206.67c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 185.2,
    y: 205.25,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-18.3 18.13) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 187.98,
    y: 204.99,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-18.26 18.38) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m191.93,206.08c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m192.39,204.64c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13-.13-1.39-1.09.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 193.54,
    y: 204.47,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.19 18.9) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 194.93,
    y: 204.34,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.17 19.03) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m196.39,205.67l1.09-.1c.16-.02.28-.16.27-.32l-.07-.8c-.02-.16-.16-.28-.32-.27l-1.09.1.13,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m200.43,203.89l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m200.56,205.28l1.09-.1c.16-.02.28-.16.27-.32l-.07-.8c-.02-.16-.16-.28-.32-.27l-1.09.1.13,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m167.5,208.36c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13-.13-1.39-1.09.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m170.09,209.22c.02.16-.11.31-.27.32l-1.09.1-.13-1.39,1.39-.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 172.82,
    y: 207.8,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-18.59 16.99) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m180.94,208.51c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m182.62,208.35l-.1-1.09c-.02-.16-.16-.28-.32-.27l-.8.07c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 183.94,
    y: 206.77,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-18.44 18.02) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m188.18,207.84l-.1-1.09c-.02-.16-.16-.28-.32-.27l-.8.07c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m190.83,206.19l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 190.89,
    y: 206.12,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.35 18.66) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 192.28,
    y: 205.99,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.34 18.79) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 193.67,
    y: 205.86,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.32 18.92) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 195.06,
    y: 205.73,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.3 19.04) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m196.69,205.64l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 167.39,
    y: 209.71,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.79 16.5) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m169.02,209.62l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m170.41,209.49c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13-.13-1.39-1.09.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m171.63,210.78l1.09-.1c.16-.02.28-.16.27-.32l-.07-.8c-.02-.16-.16-.28-.32-.27l-1.09.1.13,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m175.67,209l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m175.8,210.39l1.09-.1c.16-.02.28-.16.27-.32l-.07-.8c-.02-.16-.16-.28-.32-.27l-1.09.1.13,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m181.23,208.48l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m182.72,209.45c.02.16-.11.31-.27.32l-1.09.1-.13-1.39,1.39-.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m186.89,209.06c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m190.99,207.87l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 191.02,
    y: 207.51,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.48 18.68) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m193.84,208.41c.02.16-.11.31-.27.32l-1.09.1-.13-1.39,1.39-.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m194.04,207.29l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m195.16,207.48l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m195.23,208.28c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m199.3,206.8l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 199.36,
    y: 206.73,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.37 19.45) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m201.79,206.57c.16-.02.31.11.32.27l.1,1.09-1.39.13-.13-1.39,1.09-.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 167.52,
    y: 211.1,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.92 16.51) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 170.3,
    y: 210.84,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.88 16.77) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m171.93,210.75l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m172.06,212.14c-.16.02-.31-.11-.32-.27l.03.3.3-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 177.25,
    y: 210.19,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-18.79 17.41) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m184.44,209.59c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13-.13-1.39-1.09.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m185.66,210.87l1.09-.1c.16-.02.28-.16.27-.32l-.07-.8c-.02-.16-.16-.28-.32-.27l-1.09.1.13,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m190.92,210.38c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 191.15,
    y: 208.9,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.61 18.7) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m192.78,208.81l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m192.91,210.2c-.16.02-.31-.11-.32-.27l.03.3.3-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m199.46,208.49l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m199.53,209.28c.02.16.16.28.32.27l1.09-.1-.13-1.39-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 200.88,
    y: 207.99,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.49 19.59) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m167.69,213.65c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m170.47,213.39c.02.16.16.28.32.27l1.09-.1-.13-1.39-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 171.82,
    y: 212.1,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.99 16.92) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 173.21,
    y: 211.97,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.97 17.04) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 174.6,
    y: 211.84,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.96 17.17) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m176.06,213.17l1.09-.1c.16-.02.28-.16.27-.32l-.07-.8c-.02-.16-.16-.28-.32-.27l-1.09.1.13,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m179.01,211.49c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13-.13-1.39-1.09.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m180.23,212.78l1.09-.1c.16-.02.28-.16.27-.32l-.07-.8c-.02-.16-.16-.28-.32-.27l-1.09.1.13,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m184.37,212.1c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m185.96,210.85l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m189.83,210.49l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 189.89,
    y: 210.42,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.76 18.59) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 191.28,
    y: 210.29,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.74 18.71) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 192.67,
    y: 210.16,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.72 18.84) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 194.06,
    y: 210.03,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.7 18.97) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 195.45,
    y: 209.9,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.69 19.1) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m196.91,211.23l1.09-.1c.16-.02.28-.16.27-.32l-.07-.8c-.02-.16-.16-.28-.32-.27l-1.09.1.13,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m200.98,209.75l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 201.01,
    y: 209.38,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.61 19.61) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 178.9,
    y: 212.84,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.03 17.58) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m180.53,212.75l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 181.68,
    y: 212.58,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-18.99 17.83) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m189.99,212.17l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 190.02,
    y: 211.81,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.89 18.6) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m191.65,211.72l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m195.55,211.65l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 195.58,
    y: 211.29,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.81 19.12) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m197.2,211.2l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m200.91,212.26c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 201.14,
    y: 210.77,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.74 19.63) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m179.07,215.4c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m182.97,215.33c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m183.44,213.89c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13-.13-1.39-1.09.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m184.66,215.17l1.09-.1c.16-.02.28-.16.27-.32l-.07-.8c-.02-.16-.16-.28-.32-.27l-1.09.1.13,1.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 187.37,
    y: 213.46,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-19.05 18.36) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 190.15,
    y: 213.2,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.01 18.62) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 192.93,
    y: 212.94,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-18.98 18.88) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 195.71,
    y: 212.68,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.94 19.13) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m197.46,213.98c-.16.02-.31-.11-.32-.27l.03.3.3-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m199.82,212.36l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 199.88,
    y: 212.29,
    width: 1.4,
    height: 1.4,
    transform: "translate(-18.89 19.52) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m202.7,213.2c.02.16-.11.31-.27.32l-1.09.1-.13-1.39,1.39-.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m182.17,215.4c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13-.13-1.39-1.09.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 183.33,
    y: 215.24,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.23 18) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m184.95,215.15l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m185.08,216.54c-.16.02-.31-.11-.32-.27l.03.3.3-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 190.28,
    y: 214.59,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.14 18.64) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m192.03,215.89c-.16.02-.31-.11-.32-.27l.03.3.3-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m195.61,215.56c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 195.84,
    y: 214.07,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.07 19.15) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m198.26,213.91c.16-.02.31.11.32.27l.1,1.09-1.39.13-.13-1.39,1.09-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m180.75,218.34l-.1-1.09c-.02-.16-.16-.28-.32-.27l-.8.07c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m181.84,218.24c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m181.04,218.31c-.16.02-.31-.11-.32-.27l.03.3.3-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 182.07,
    y: 216.75,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.38 17.89) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 183.46,
    y: 216.63,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.36 18.02) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m185.88,216.46c.16-.02.31.11.32.27l.1,1.09-1.39.13-.13-1.39,1.09-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m189.09,217.56l-.1-1.09c-.02-.16-.16-.28-.32-.27l-.8.07c-.16.02-.28.16-.27.32l.1,1.09,1.39-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m190.18,217.46c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m189.38,217.54c-.16.02-.31-.11-.32-.27l.03.3.3-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 190.41,
    y: 215.98,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.27 18.66) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 191.8,
    y: 215.85,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.25 18.79) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 193.19,
    y: 215.72,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.23 18.91) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 194.58,
    y: 215.59,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.22 19.04) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 195.97,
    y: 215.46,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.2 19.17) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m198.79,216.36c.02.16-.11.31-.27.32l-1.09.1-.13-1.39,1.39-.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 179.42,
    y: 218.4,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.54 17.65) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 180.81,
    y: 218.27,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.53 17.78) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 182.2,
    y: 218.14,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.51 17.9) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m183.82,218.06l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m184.95,218.25l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 184.98,
    y: 217.89,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.47 18.16) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m187.53,219.11c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m186.73,219.19c-.16.02-.31-.11-.32-.27l.03.3.3-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 187.76,
    y: 217.63,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.44 18.42) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 189.15,
    y: 217.5,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.42 18.55) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m191.97,218.4c.02.16-.11.31-.27.32l-1.09.1-.13-1.39,1.39-.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m192.16,217.28l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m193.28,217.47l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m193.36,218.27c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m194.94,217.02l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m196.06,217.21l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 196.16,
    y: 216.85,
    width: 1.4,
    height: 2.79,
    transform: "translate(-19.39 19.2) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m197.72,216.76l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m201.6,216.4l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m202.69,216.3c.16-.02.31.11.32.27l.1,1.09-1.39.13-.13-1.39,1.09-.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 179.55,
    y: 219.79,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.67 17.67) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m181.17,219.7l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m182.3,219.9l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m182.37,220.7c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 185.11,
    y: 219.28,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.6 18.18) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 186.5,
    y: 219.15,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.58 18.31) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 187.89,
    y: 219.02,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.56 18.44) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m189.51,218.93l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m196.13,221.11c.16-.02.28-.16.27-.32l.03.3-.3.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 196.36,
    y: 219.63,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.58 19.22) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m198.11,220.93c-.16.02-.31-.11-.32-.27l.03.3.3-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 199.01,
    y: 217.98,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-19.42 19.46) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m201.75,218.09l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m201.83,218.88c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 179.68,
    y: 221.18,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.8 17.68) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m185.28,221.83c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m186.86,220.58l-.3.03.03.3c-.02-.16.11-.31.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m187.98,220.77l-.03-.3-.3.03c.16-.02.31.11.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m188.06,221.57c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m192.26,221.48l-1.09.1c-.16.02-.28.16-.27.32l.07.8c.02.16.16.28.32.27l1.09-.1-.13-1.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 192.32,
    y: 221.41,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.77 18.86) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 193.71,
    y: 221.28,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.75 18.99) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 195.1,
    y: 221.15,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.73 19.11) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 196.49,
    y: 221.02,
    width: 1.4,
    height: 1.4,
    transform: "translate(-19.71 19.24) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m197.95,222.35l1.09-.1c.16-.02.28-.16.27-.32l-.07-.8c-.02-.16-.16-.28-.32-.27l-1.09.1.13,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m179.85,223.74c.02.16.16.28.32.27l.8-.07c.16-.02.28-.16.27-.32l-.1-1.09-1.39.13.1,1.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 186.76,
    y: 221.93,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-19.84 18.34) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 192.06,
    y: 218.63,
    width: 1.4,
    height: 1.4,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-19.51 18.82) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m174.01,191.1l.62,6.61c0,.09-.06.18-.15.19l-6.61.62c-.09,0-.18-.06-.19-.15l-.62-6.61c0-.09.06-.18.15-.19l6.61-.62c.09,0,.18.06.19.15Zm-8.21-.81c-.16.02-.27.12-.25.29l.85,9.18c.02.16.16.28.32.27l9.14-.85c.16-.02.28-.16.27-.32l-.85-9.14c-.02-.16-.16-.28-.32-.27l-9.16.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 167.7,
    y: 191.59,
    width: 6.28,
    height: 6.29,
    rx: 0.45,
    ry: 0.45,
    transform: "translate(-17.32 16.68) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m199.02,188.77l.62,6.61c0,.09-.06.18-.15.19l-6.61.62c-.09,0-.18-.06-.19-.15l-.62-6.61c0-.09.06-.18.15-.19l6.61-.62c.09,0,.18.06.19.15Zm-8.19-.81c-.16.02-.28.16-.27.32l.85,9.14c.02.16.16.28.32.27l9.14-.85c.16-.02.28-.16.27-.32l-.85-9.14c-.02-.16-.22-.27-.38-.26l-9.08.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 192.71,
    y: 189.26,
    width: 6.28,
    height: 6.29,
    rx: 0.45,
    ry: 0.45,
    transform: "translate(-17 18.99) rotate(-5.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m176.34,216.12l.62,6.61c0,.09-.06.18-.15.19l-6.61.62c-.09,0-.18-.06-.19-.15l-.62-6.61c0-.09.06-.18.15-.19l6.61-.62c.09,0,.18.06.19.15Zm-8.19-.81c-.16.02-.28.16-.27.32l.84,9.03c.02.16.26.38.42.37l9.05-.84c.16-.02.28-.16.27-.32l-.85-9.14c-.02-.16-.16-.28-.32-.27l-9.14.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 170.03,
    y: 216.61,
    width: 6.28,
    height: 6.29,
    rx: 0.45,
    ry: 0.45,
    transform: "translate(-19.63 17.01) rotate(-5.32)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacturacion);
export default __webpack_public_path__ + "static/media/Facturacion.d24a6dbfeeabb5a0437a5af9a82a89c6.svg";
export { ForwardRef as ReactComponent };